(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"C:\\projects\\lightning\\business-objects\\GeneratedCollectionDetails.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('underscore');

// ref: OverDrive.Thunder.Models.DataModels.GeneratedCollectionDetails
module.exports = function () {
    function GeneratedCollectionDetails() {
        _classCallCheck(this, GeneratedCollectionDetails);

        this.mediaType = '';
        this.language = '';
        this.publisherEntityId = null; // int
        this.maturityLevels = []; // string
        this.subjects = []; // string

        this.sortBy = '';
        this.maxItems = undefined; // int

        Object.assign.apply(Object, [this].concat(Array.prototype.slice.call(arguments)));
    }

    // Translates GeneratedCollectionDetails model to parameters that align with the MediaParameters model for executing a "search"


    _createClass(GeneratedCollectionDetails, [{
        key: 'serializeForSearch',
        value: function serializeForSearch() {
            var model = _.extend({}, this);

            // language is an array in MediaParameters
            model.language = _(_.flatten([model.language])).reject(function (val) {
                return _.isEmpty(val);
            });

            // maturityLevels is called maturityLevel
            model.maturityLevel = _(_.flatten([model.maturityLevels])).reject(function (val) {
                return _.isEmpty(val);
            });
            delete model.maturityLevels;

            // subjects is called subject
            model.subject = _(_.flatten([model.subjects])).reject(function (val) {
                return _.isEmpty(val);
            });
            delete model.subjects;

            return model;
        }
    }]);

    return GeneratedCollectionDetails;
}();

},{"underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\models\\dao\\MediaParameters.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('underscore');

/**
 * Defines all the available input parameters for the media endpoint
 * @class MediaParameters
 * ref: https://thunder-api.test.overdrive.com/docs/ui/index#!/Media/V2Media_IndexMedia
 */
module.exports = function () {
    function MediaParameters() {
        _classCallCheck(this, MediaParameters);

        this.query = '';
        this.mediaType = '';
        this.title = '';
        this.series = '';
        this.publisherId = '';
        this.publisherEntityId = null;
        this.imprintId = '';
        this.identifier = '';
        this.creator = '';
        this.creatorId = null;
        this.addedDate = '';
        this.availableFirst = null;
        this.showOnlyAvailable = false;
        this.showOnlyPrerelease = false;
        this.showOnlyLuckyDayAvailable = false;
        this.hasAudioSynchronizedText = null;
        this.collectionId = 0;

        // All of the following arrays are string arrays
        this.format = [];
        this.subject = [];
        this.bisacCode = [];
        this.maturityLevel = [];
        this.language = [];
        this.atosLevel = [];
        this.lexileScore = [];
        this.interestLevel = [];
        this.gradeLevel = [];
        this.includedFacets = [];

        this.sortBy = 'relevance';
        this.show = 'owned';
        this.page = 1;
        this.perPage = 24;
        this.includeFacets = true;
        this.includeNoFormatTitles = false;
        this.filterCpcTitles = false;
        this.maxItems = 0;

        Object.assign.apply(Object, [this].concat(Array.prototype.slice.call(arguments)));
    }

    _createClass(MediaParameters, [{
        key: 'applyRoomFiltersAndUserPrefs',
        value: function applyRoomFiltersAndUserPrefs(roomFilters, userPreferences) {
            if (roomFilters) {
                // Note that the names don't match up so we can't just extend
                if (roomFilters.maturityLevels) {
                    this.maturityLevel = roomFilters.maturityLevels;
                }
                if (roomFilters.subjects) {
                    this.subject = roomFilters.subjects;
                }
                if (roomFilters.language) {
                    this.language = roomFilters.language;
                }
                if (roomFilters.mediaType) {
                    this.mediaType = roomFilters.mediaType;
                }
            }

            if (userPreferences) {
                // There may be more user prefs to apply besides audience-settings but this
                // was the immediate need.  We can add more as they come up.
                if (userPreferences['audience-setting'] && this.maturityLevel.length === 0) {
                    var audience = userPreferences['audience-setting'];
                    var maturityLevels = [];
                    _.each(_.keys(audience), function (key) {
                        if (audience[key] && key !== 'all') {
                            maturityLevels.push(key);
                        }
                    });
                    if (maturityLevels.length > 0) {
                        this.maturityLevel = maturityLevels;
                    }
                }
            }
        }
    }, {
        key: 'serialize',
        value: function serialize() {
            var _this = this;

            var response = _.extend({}, this);

            // Remove all properties that do not have a value set
            Object.keys(response).forEach(function (key) {
                !_this._hasValue(response[key]) && delete response[key];
            });

            return response;
        }
    }, {
        key: '_hasValue',
        value: function _hasValue(value) {
            return !(_(value).isObject() && _(value).isEmpty() || !value) || value === false;
        }
    }]);

    return MediaParameters;
}();


},{"underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\node_modules\\he\\he.js":[function(require,module,exports){
(function (global){
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return he;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = he;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in he) {
				has(he, key) && (freeExports[key] = he[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.he = he;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js":[function(require,module,exports){
(function (process){
// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))

},{"_process":"C:\\projects\\lightning\\node_modules\\process\\browser.js"}],"C:\\projects\\lightning\\node_modules\\process\\browser.js":[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],"C:\\projects\\lightning\\node_modules\\querystring-es3\\decode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring-es3\\encode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js":[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":"C:\\projects\\lightning\\node_modules\\querystring-es3\\decode.js","./encode":"C:\\projects\\lightning\\node_modules\\querystring-es3\\encode.js"}],"C:\\projects\\lightning\\node_modules\\querystring\\decode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring\\encode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring\\index.js":[function(require,module,exports){
arguments[4]["C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js"][0].apply(exports,arguments)
},{"./decode":"C:\\projects\\lightning\\node_modules\\querystring\\decode.js","./encode":"C:\\projects\\lightning\\node_modules\\querystring\\encode.js"}],"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js":[function(require,module,exports){
(function (global){
//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define == 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}());

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\collection_campaign_page\\CollectionDefinition.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MediaInterface = require('../media/MediaInterface');

var _MediaInterface2 = _interopRequireDefault(_MediaInterface);

var _GeneratedCollectionDetails = require('../../../../business-objects/GeneratedCollectionDetails');

var _GeneratedCollectionDetails2 = _interopRequireDefault(_GeneratedCollectionDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// ref: Thunder.Models.ResponseModels.CollectionDefinition
var CollectionDefinition = function (_Backbone$Model) {
    _inherits(CollectionDefinition, _Backbone$Model);

    _createClass(CollectionDefinition, [{
        key: 'defaults',
        value: function defaults() {
            return {
                id: '0',
                name: '',
                description: '',
                availabilityOption: '',
                showOnlyAvailable: false,
                showOnlyPrerelease: false,
                sortByAvailability: false,
                curatedCollectionDetails: null,
                generatedCollectionDetails: null,
                lastModified: null,
                order: 0,

                // Computed property
                totalItems: 0
            };
        }
    }, {
        key: 'idAttribute',
        get: function get() {
            return 'id';
        }
    }, {
        key: 'collectionOptions',
        get: function get() {
            var options = {
                includeFacets: false,
                perPage: this.pageSize || 6,
                shuffle: this.shuffle || this.isLuckyDay
            };
            if (this.get('sortByAvailability') || this.get('availabilityOption') === 'available-first') {
                options.availableFirst = true;
            }
            if (this.get('showOnlyAvailable') || this.get('availabilityOption') === 'available-only') {
                options.showOnlyAvailable = true;
            }
            if (this.get('showOnlyPrerelease')) {
                options.showOnlyPrerelease = true;
            }
            if (this.useListOrder) {
                options.sortBy = 'listorder';
            }

            return options;
        }
    }, {
        key: 'isLuckyDay',
        get: function get() {
            return this.get('availabilityOption') === 'available-luckyday';
        }
    }, {
        key: 'isGenerated',
        get: function get() {
            return !_(this.get('generatedCollectionDetails')).isEmpty();
        }
    }, {
        key: 'isCurated',
        get: function get() {
            return !_(this.get('curatedCollectionDetails')).isEmpty();
        }
    }, {
        key: 'useListOrder',
        get: function get() {
            return this.isCurated && this.get('curatedCollectionDetails').isOrdered;
        }

        /**
         * @prop {TitleCollection} collection
         * @memberof CollectionDefinition
         */

    }]);

    function CollectionDefinition() {
        _classCallCheck(this, CollectionDefinition);

        var _this = _possibleConstructorReturn(this, (CollectionDefinition.__proto__ || Object.getPrototypeOf(CollectionDefinition)).apply(this, arguments));

        _this._mediaInterface = new _MediaInterface2['default']();

        _this.titleCollection = _this._mediaInterface.items;

        _this.listenTo(_this.titleCollection, 'all', function () {
            _this.set('totalItems', _this.titleCollection.length);
        });
        return _this;
    }

    _createClass(CollectionDefinition, [{
        key: 'fetchCollectionTitles',
        value: function fetchCollectionTitles(_ref) {
            var patronSettings = _ref.patronSettings,
                room = _ref.room;

            // Parse the current room's maturityLevels if there is a room, and a maturityLevels filter has been set
            var roomHasMaturityLevelFilter = !_.isEmpty(room && room.filters && room.filters.maturityLevels);

            var patronMaturityLevelPreferences = this._parsePatronAudienceSettings(patronSettings);

            if (this.isGenerated) {
                var genColDetails = this.get('generatedCollectionDetails');
                if (this.attributes.sortBy) {
                    genColDetails.sortBy = this.attributes.sortBy;
                }
                if (!!this.get('showOnlyLuckyDayAvailable')) {
                    genColDetails.showOnlyLuckyDayAvailable = true;
                }
                var details = new _GeneratedCollectionDetails2['default'](genColDetails);
                var params = details.serializeForSearch();

                if (!!patronSettings.showOnlyAvailable) {
                    params.showOnlyAvailable = true;
                }

                // If we are in a room with maturity filters applied, the filters will be apart of the collection definition and we can simply query for the collection
                // User preferences should NOT override a room's maturity filter
                if (roomHasMaturityLevelFilter) {
                    return this._mediaInterface.fetchCollectionByParameters(params, this.collectionOptions);
                }
                // Otherwise determine if the User's maturity filter settings cover the collection's maturityLevel settings
                else {
                        var generatedCollectionOptions = Object.assign({}, this.collectionOptions);

                        if (!_(patronMaturityLevelPreferences).isEmpty() && _(params.maturityLevel).isEmpty()) {
                            Object.assign(generatedCollectionOptions, { maturityLevel: patronMaturityLevelPreferences });
                        }

                        // Fake an empty response if all the auto generated collection's filters are not covered by the user's maturity level settings
                        return this._patronFiltersPermitCollection(params.maturityLevel, patronMaturityLevelPreferences) ? this._mediaInterface.fetchCollectionByParameters(params, generatedCollectionOptions) : this._mediaInterface.fetchEmptyResponse();
                    }
            }
            // else if "isCurated"
            else {
                    var curatedCollectionOptions = Object.assign({}, this.collectionOptions);

                    if (!!patronSettings.showOnlyAvailable) {
                        curatedCollectionOptions.showOnlyAvailable = true;
                    }

                    // If we are NOT in a room, apply a user's maturity settings if present to the collection request
                    // The expectation is that if none of the content satisfies the user's filter its acceptable that no results are returned
                    if (_(room).isEmpty()) {
                        Object.assign(curatedCollectionOptions, { maturityLevel: patronMaturityLevelPreferences });
                    }

                    return this._mediaInterface.fetchCollectionById(this.id, curatedCollectionOptions);
                }
        }

        // Convert the patron audience settings model into an array of filter terms that MediaInterface understands, ex:
        // "audience-setting": {
        //     "all"            : false,
        //     "juvenile"       : false,
        //     "youngadult"     : true,
        //     "generalcontent" : true,
        //     "adultonly"      : true
        // }
        // to: ["youngadult", "generalcontent", "adultonly"]
        /** @returns {string[]} */

    }, {
        key: '_parsePatronAudienceSettings',
        value: function _parsePatronAudienceSettings(patronSettings) {
            var patronAudienceSetting = patronSettings && patronSettings['audience-setting'] || {};

            if (_(patronAudienceSetting).isEmpty() || patronAudienceSetting.all) {
                return [];
            }

            var audienceFilters = [];
            _(patronAudienceSetting).each(function (isApplied, key) {
                if (isApplied && key !== "all") {
                    audienceFilters.push(key);
                }
            });

            return audienceFilters;
        }
    }, {
        key: '_patronFiltersPermitCollection',
        value: function _patronFiltersPermitCollection() {
            var collectionMaturityFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var userMaturityFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            if (userMaturityFilters.length === 0) {
                return true;
            }

            var collectionLower = collectionMaturityFilters.map(function (filter) {
                return filter.toLowerCase();
            });
            var userLower = userMaturityFilters.map(function (filter) {
                return filter.toLowerCase();
            });

            return _(collectionLower).difference(userLower).length === 0;
        }
    }]);

    return CollectionDefinition;
}(Backbone.Model);

exports['default'] = CollectionDefinition;

},{"../../../../business-objects/GeneratedCollectionDetails":"C:\\projects\\lightning\\business-objects\\GeneratedCollectionDetails.js","../media/MediaInterface":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\collection_campaign_page\\PageManager.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CollectionDefinition = require('./CollectionDefinition');

var _CollectionDefinition2 = _interopRequireDefault(_CollectionDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageManager = function (_Backbone$Model) {
    _inherits(PageManager, _Backbone$Model);

    function PageManager() {
        _classCallCheck(this, PageManager);

        return _possibleConstructorReturn(this, (PageManager.__proto__ || Object.getPrototypeOf(PageManager)).apply(this, arguments));
    }

    _createClass(PageManager, [{
        key: 'fetchRoomById',


        // page == room, page has views, one of which is the home-page collections collection
        // ref: /v2/libraries/qa/pages
        value: function fetchRoomById() {
            var _this2 = this;

            var roomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'home';

            this.url = window.url(window.routes.rest.rooms.get, { roomId: roomId });

            return new Promise(function (resolve, reject) {
                _this2.fetch({
                    timeout: 10000,
                    success: function success(model, response, options) {
                        return resolve(response);
                    },
                    error: function error(model, response, options) {
                        return reject(response);
                    }
                });
            });
        }
    }, {
        key: 'fetchCampaignById',
        value: function fetchCampaignById(campaignId) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: window.url(window.routes.rest.campaigns.get, { campaignId: campaignId }),
                    dataType: 'json',
                    timeout: 10000
                }).done(function (response) {
                    return resolve(response);
                }).fail(function (jqHXR, textStatus, errorThrown) {
                    return reject(jqHXR);
                });
            });
        }
    }, {
        key: 'fetchCollectionById',
        value: function fetchCollectionById(collectionId) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: window.url(window.routes.rest.collections.getById, { id: collectionId }),
                    dataType: 'json',
                    timeout: 10000
                }).done(function (response) {
                    return resolve(new _CollectionDefinition2['default'](response));
                }).fail(function (jqHXR, textStatus, errorThrown) {
                    return reject(jqHXR);
                });
            });
        }
    }, {
        key: 'getView',
        value: function getView(viewName) {
            if (!this.isLoaded) {
                return null;
            }

            return (viewName || '').toLowerCase() === 'home' ? _(this.attributes.views).findWhere({ isDefault: true }) : _(this.attributes.views).findWhere({ name: viewName });
        }
    }, {
        key: 'getCampaigns',
        value: function getCampaigns() {
            return this.isLoaded && this.attributes.campaigns;
        }
    }, {
        key: 'idAttribute',
        get: function get() {
            return 'pageId';
        }
    }, {
        key: 'isLoaded',
        get: function get() {
            return !_.isEmpty(this.attributes);
        }
    }]);

    return PageManager;
}(Backbone.Model);

exports['default'] = PageManager;

},{"./CollectionDefinition":"C:\\projects\\lightning\\public\\ecmascript\\components\\collection_campaign_page\\CollectionDefinition.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HashManager = function () {
    function HashManager() {
        _classCallCheck(this, HashManager);
    }

    _createClass(HashManager, null, [{
        key: 'parse',
        value: function parse() {
            var hashObject = _querystring2['default'].parse(location.hash.substr(1));

            _.keys(hashObject).forEach(function (key) {
                hashObject[key] = _.flatten([hashObject[key] || []]);
            });

            return hashObject;
        }
    }, {
        key: 'update',
        value: function update(object) {
            var newHash = _querystring2['default'].stringify(object);
            if (newHash !== '&') {
                location.hash = newHash;
            }
        }
    }, {
        key: 'get',
        value: function get(key) {
            var response = this.parse();

            if (_.isString(key)) {
                return response[key];
            }

            return response;
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            var hash = this.parse();

            hash[key] = _.flatten([value]);

            this.update(hash);
        }
    }, {
        key: 'push',
        value: function push(key, value) {
            var hash = this.parse();

            hash[key] = hash[key] || [];
            hash[key].push(value);

            this.update(hash);
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            var hash = this.parse();

            hash[key] && delete hash[key];

            this.update(hash);
        }
    }]);

    return HashManager;
}();

exports['default'] = HashManager;

},{"querystring":"C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Modal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keycodes = require('../../util/keycodes');

var _keycodes2 = _interopRequireDefault(_keycodes);

var _modal = require('./templates/modal.html');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Backbone$View) {
    _inherits(Modal, _Backbone$View);

    function Modal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Modal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.isSelectEvent = function (e) {
            return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Modal, [{
        key: 'initialize',
        value: function initialize(options) {
            _.extend(this, this.defaults, options);

            this.tpl = _modal2['default'];
            this.setElement(this.tpl(this));

            if (this.id.length) {
                this.$el.attr('id', this.id);
            }

            this.$content = this.$el.find('.modal-container');

            this.$content.empty().append(this.content);

            this.$el.addClass(this.classes.join(' '));

            this.$title = this.$el.find('.modal-title');

            if (this.hiddenTitle) {
                this.$title.css("opacity", "0");
            }

            if (this.autoRender) {
                this._render();
            }

            this._bindEvents();
        }
    }, {
        key: '_render',
        value: function _render() {
            if (this.attachToDocument) {
                // For Foundation to work as expected we need to have the element attached to the DOM before calling .foundation('reveal', 'open')
                $('body').append(this.el);
            }

            if (this.autoShow) {
                this.show();
            }

            return this;
        }
    }, {
        key: '_bindEvents',


        // We dont actually want to use the Foundation modal events since they get weird fast...
        // lets use our own so consumers dont have to know its foundation
        value: function _bindEvents() {
            var _this2 = this;

            this.$el.on('click keydown', '.js-close', function (e) {
                _this2.isSelectEvent(e) && _this2.trigger('cancel', _this2);
            });

            if (this.defaultButtonBehaviour) {
                this.on('close cancel', function () {
                    _this2.close();
                });
            }

            this.$el.on('keypress', '*', function (e) {
                if (e.which === _keycodes2['default'].TAB) {
                    _this2._keepFocus(e);
                }
            });
        }
    }, {
        key: 'show',
        value: function show() {
            var _this3 = this;

            this._beforeShow();
            this.$el.foundation('reveal', 'open');
            this.trigger('show', this);

            this.$el.on('keydown', function (e) {
                _this3._keepFocus(e);
            });

            // Execute code after the modal is displayed
            this.$el.on('opened.fndtn.reveal', function () {
                return _this3._afterShow();
            });

            // Traps foundation bug that closes modal on dropdown "closed", not an issue in 5.5.3+
            this.$el.off('closed');

            // Handle foundation  close events from ESC and BG clicks
            this.$el.on('close.fndtn.reveal', function () {
                _this3.$el.off('close.fndtn.reveal');
                _this3.trigger('close');
            });
        }
    }, {
        key: '_beforeShow',
        value: function _beforeShow() {
            this.focused = $(document.activeElement);
        }
    }, {
        key: '_afterShow',
        value: function _afterShow() {
            this.$el.attr('aria-hidden', false);
            $('.container').attr('aria-hidden', 'true');
            $('.row.footer').attr('aria-hidden', 'true');
            $('.nav-container').attr('aria-hidden', 'true');

            this.$title.focus();
            this._setScroll();
        }
    }, {
        key: '_setScroll',
        value: function _setScroll() {
            var offset = window.pageYOffset - parseInt(this.$el.css('top').slice(0, -2), 10); // the 'top' styling is baked in by foundation
            if (window.innerHeight < this.el.offsetHeight - offset) {
                // scroll tall modals into view as much as fits
                offset = Math.min(this.el.offsetHeight - window.innerHeight + 10, -5);
            } else if (window.innerWidth < 641) {
                // mobile view padding
                offset -= 5;
            }
            this.el.scrollIntoView(); // sets scroll to top of modal
            window.scrollBy(0, offset); // adjusts scroll according to calculated offset
        }
    }, {
        key: '_keepFocus',
        value: function _keepFocus(e) {
            var activeElem = $(document.activeElement);
            var firstFocusable = this.$title || this.$el.find(':focusable:visible').first();
            var lastFocusable = this.$el.find(':focusable:visible').last();

            if (activeElem.is(firstFocusable) && e.which === _keycodes2['default'].TAB && e.shiftKey) {
                e.preventDefault();
                lastFocusable.focus();
            } else if ($(activeElem).is(lastFocusable) && e.which === _keycodes2['default'].TAB && !e.shiftKey) {
                e.preventDefault();
                firstFocusable.focus();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.$el.foundation('reveal', 'close');
            this.trigger('hide', this);
            $('.container').attr('aria-hidden', 'false');
            $('.row.footer').attr('aria-hidden', 'false');
            $('.nav-container').attr('aria-hidden', 'false');
            this.focused.focus();
        }
    }, {
        key: 'close',
        value: function close() {
            this.hide();
            this.remove();
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                autoShow: true,
                autoRender: true,
                closeOnEsc: true,
                closeOnBlur: true,

                id: '',
                classes: ['small'],
                buttonAlign: 'right',
                title: 'Title',
                hiddenTitle: false,
                content: 'Some Content',
                submitText: html('ok'),
                cancelText: html('cancel'),
                attachToDocument: true,
                defaultButtonBehaviour: true,
                showCloseButton: true
            };
        }
    }]);

    return Modal;
}(Backbone.View);

exports.Modal = Modal;


},{"../../util/keycodes":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js","./templates/modal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\templates\\modal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\templates\\modal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var title = _ref.title,
        closeOnEsc = _ref.closeOnEsc,
        closeOnBlur = _ref.closeOnBlur,
        showCloseButton = _ref.showCloseButton;
    return '<div class="reveal-modal" aria-hidden="true" role="dialog" data-reveal data-options="close_on_esc:' + closeOnEsc + ';close_on_background_click:' + closeOnBlur + ';">\n    <div class="modal-header">\n        <h2 class="modal-title primary-color" tabindex="0">' + title + '</h2>\n        ' + (showCloseButton ? '<a class="close-reveal-modal js-close" role="button" aria-label="' + window.html('close') + '" tabindex="0">&#215;</a>' : '') + '\n    </div>\n\n    <div class="modal-container"></div>\n</div>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationModalV2.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../common/modal');

var _HoldInformationV = require('./HoldInformationV2');

var _HoldInformationV2 = _interopRequireDefault(_HoldInformationV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldInformationModalV2 = function (_Modal) {
    _inherits(HoldInformationModalV2, _Modal);

    function HoldInformationModalV2(_ref) {
        var model = _ref.model,
            _ref$hideHoldsLink = _ref.hideHoldsLink,
            hideHoldsLink = _ref$hideHoldsLink === undefined ? false : _ref$hideHoldsLink;

        _classCallCheck(this, HoldInformationModalV2);

        var information = new _HoldInformationV2['default']({ model: model, hideHoldsLink: hideHoldsLink, isVisitor: window.OverDrive.isVisitor }).render();
        var modalContents = {
            classes: ['HoldInformationModalV2'],
            title: window.html('holdsRatioHelpModal.heading'),
            content: information.el
        };
        return _possibleConstructorReturn(this, (HoldInformationModalV2.__proto__ || Object.getPrototypeOf(HoldInformationModalV2)).call(this, modalContents));
    }

    return HoldInformationModalV2;
}(_modal.Modal);

exports['default'] = HoldInformationModalV2;

},{"../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./HoldInformationV2":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    text = _window.text;

exports['default'] = function (_ref) {
    var description = _ref.description,
        details = _ref.details,
        note = _ref.note;
    return '\n    ' + (description && description.length > 0 ? '<p class=\'description\'>' + description + '</p>' : '') + '\n    ' + (details && details.map(function (detail) {
        return '<p class=\'detail\'><span class=\'holdInfoLabel\'>' + detail.label + ': </span><span>' + detail.value + '</span></p>';
    }).join('')) + '\n    ' + (note && note.length > 0 ? '<p class=\'note\'>' + note + '</p>' : '') + '\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldInformationV = require('./HoldInformationV2.html');

var _HoldInformationV2 = _interopRequireDefault(_HoldInformationV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    text = _window.text;

var HoldInformationV2 = function (_Backbone$View) {
    _inherits(HoldInformationV2, _Backbone$View);

    function HoldInformationV2(_ref) {
        var _ref$hideHoldsLink = _ref.hideHoldsLink,
            hideHoldsLink = _ref$hideHoldsLink === undefined ? false : _ref$hideHoldsLink,
            _ref$isVisitor = _ref.isVisitor,
            isVisitor = _ref$isVisitor === undefined ? false : _ref$isVisitor;

        _classCallCheck(this, HoldInformationV2);

        var _this = _possibleConstructorReturn(this, (HoldInformationV2.__proto__ || Object.getPrototypeOf(HoldInformationV2)).apply(this, arguments));

        _this.el = _this.el || document.createElement('div');
        _this.hideHoldsLink = hideHoldsLink;
        _this.isVisitor = isVisitor;
        _this.MAX_WAIT_MONTHS_TO_SHOW = 6;
        _this.MAX_WAIT_WEEKS_TO_SHOW = 26;
        _this.listenTo(_this.model, 'change:titleState', _this.removeWaitTime);
        return _this;
    }

    _createClass(HoldInformationV2, [{
        key: 'render',
        value: function render() {
            var view = (0, _HoldInformationV2['default'])({
                description: this.description,
                details: this.details,
                note: this.note
            });
            this.$el.empty().append(view);

            return this;
        }
    }, {
        key: 'removeWaitTime',
        value: function removeWaitTime() {
            if (window.featureManager.isEnabled('addWaitTimeToWishlist') && this.hideWaitTime) {
                this.$el.hide();
            }
        }
    }, {
        key: 'description',
        get: function get() {
            if (this.isPrereleaseTitle) {
                return text('expectedWaitTime.prereleaseNoWaitTime');
            } else if (this.isExpiredTitle) {
                var theText = '';
                if (this.model.get('titleState') === 'onHold') {
                    theText = text('holdsRatioHelpModal.noCopiesOnPlaceHold');
                } else {
                    theText = text('holdsRatioHelpModal.noCopiesText');
                }
                return this.hideHoldsLink ? theText : '<span>' + theText + '<a class="manageHoldsLink" target="_blank" href="/account/holds">' + text('holdSuccessModal.manageHolds') + '</a></span>';
            } else if (this.model.allCopiesAreLuckyDay && this.model.get('titleState') === 'onHold') {
                var detailsUrl = window.url(window.routes.mediaId, { id: this.model.get('id') });
                var detailsLink = '<a style="text-decoration: underline" href="' + detailsUrl + '">' + text('luckyDay.allLuckyDayHoldsInfoLinkText') + '</a>';
                return text('luckyDay.allLuckyDayHoldsInfo', { link: detailsLink });
            } else if (this.isFastLaneTitle) {
                return text('expectedWaitTime.advantageCaveat');
            } else if (this.isVisitor) {
                return text('expectedWaitTime.rlaCaveat');
            }
            return '';
        }
    }, {
        key: 'details',
        get: function get() {
            var details = [];
            if (!this.showWaitTimeUnavailable && !this.hideWaitTime) {
                details.push({ label: text('expectedWaitTime.waitTime'), value: this.waitTimeText });
            }

            if (this.model.get('holdListPosition')) {
                details.push({ label: text('expectedWaitTime.placeInLine'), value: this.model.get('holdListPosition') });
            }

            var ownedCopies = this.model.get('ownedCopies') || 0;
            var totalHolds = this.model.get('holdsCount') || 0;

            details.push({ label: text('expectedWaitTime.libraryCopies'), value: ownedCopies });

            if (ownedCopies > 1) {
                var holdsRatio = ownedCopies && totalHolds ? totalHolds / ownedCopies : 0;
                var ratioDisplayValue = holdsRatio > 0 && holdsRatio < 1 ? '< 1' : Math.round(holdsRatio);
                details.push({ label: text('expectedWaitTime.peopleWaitingTotal'), value: totalHolds });
                details.push({ label: text('expectedWaitTime.poepleWaitingPerCopy'), value: ratioDisplayValue });
            } else {
                details.push({ label: text('expectedWaitTime.peopleWaiting'), value: totalHolds });
            }
            return details;
        }
    }, {
        key: 'waitTimeHtml',
        get: function get() {
            var html = '';
            if (!this.hideWaitTime) {
                html = '<span class=\'waitingText\'>' + window.text('expectedWaitTime.waitTime') + ': ' + this.waitTimeText + '</span>';
            }
            return html;
        }
    }, {
        key: 'waitTimeText',
        get: function get() {
            var waitTimeText = '';

            if (!this.hideWaitTime) {
                if (this.showWaitTimeUnavailable) {
                    waitTimeText = text('expectedWaitTime.notAvailable');
                } else {
                    var estimatedWaitDays = Number(this.model.get('estimatedWaitDays'));
                    if (estimatedWaitDays <= 7) {
                        waitTimeText = text('expectedWaitTime.availableSoon');
                    } else if (estimatedWaitDays < 7 * this.MAX_WAIT_WEEKS_TO_SHOW) {
                        waitTimeText = text('expectedWaitTime.aboutXWeeks', { weeks: Math.ceil(estimatedWaitDays / 7) });
                    } else {
                        // we intentionally max out at "at least 6 months"
                        waitTimeText = text('expectedWaitTime.atLeastYMonths', { months: Math.min(Math.ceil(estimatedWaitDays / 30), this.MAX_WAIT_MONTHS_TO_SHOW) });
                    }
                }
            }

            return waitTimeText;
        }
    }, {
        key: 'showWaitTimeUnavailable',
        get: function get() {
            return this.model.get('estimatedWaitDays') === undefined || this.model.get('estimatedWaitDays') === null || this.isPrereleaseTitle || this.isVisitor || this.isExpiredTitle;
        }
    }, {
        key: 'hideWaitTime',
        get: function get() {
            return this.isFastLaneTitle || this.model.get('titleState') === 'onHold' || (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isBorrowed') : this.model.get('titleState') === 'borrowed');
        }
    }, {
        key: 'isExpiredTitle',
        get: function get() {
            return this.model.get('isOwned') && !this.model.get('ownedCopies') && !this.model.allCopiesAreLuckyDay;
        }
    }, {
        key: 'isFastLaneTitle',
        get: function get() {
            return this.model.get('isFastlane');
        }
    }, {
        key: 'isPrereleaseTitle',
        get: function get() {
            return this.model.get('isPreReleaseTitle');
        }
    }, {
        key: 'note',
        get: function get() {
            return [];
        }
    }]);

    return HoldInformationV2;
}(Backbone.View);

exports['default'] = HoldInformationV2;

},{"./HoldInformationV2.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\templates\\HoldInformation.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var expirationWarning = _ref.expirationWarning,
        description = _ref.description,
        details = _ref.details,
        note = _ref.note;
    return '\n    ' + (expirationWarning.length > 0 ? '<p class=\'expiration-warning\'>' + expirationWarning + '</p>' : '') + '\n    ' + (description.length > 0 ? '<p class=\'description\'>' + description + '</p>' : '') + '\n    ' + details.map(function (detail) {
        return '<p class=\'detail\'>' + detail + '</p>';
    }).join('') + '\n    ' + (note.length > 0 ? '<p class=\'note\'>' + note + '</p>' : '') + '\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformation.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldInformation = require('../templates/HoldInformation.html');

var _HoldInformation2 = _interopRequireDefault(_HoldInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

var HoldInformation = function (_Backbone$View) {
    _inherits(HoldInformation, _Backbone$View);

    _createClass(HoldInformation, [{
        key: 'expirationWarning',
        get: function get() {
            var isExpiredContent = this.model.get('isOwned') && !this.model.get('ownedCopies');
            if (isExpiredContent) {
                if (this.type === 'successPosition') {
                    return html('holdsRatioHelpModal.noCopiesOnPlaceHold') + ' <a class=\'HoldSuccessModal-link\' href=\'' + url(routes.accountHolds) + '\'>' + html('holdSuccessModal.manageHolds') + '</a>';
                } else if (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isOnHold') : this.model.get('titleState') === 'onHold') {
                    return html('holdsRatioHelpModal.noCopiesTextHeld');
                }
                return html('holdsRatioHelpModal.noCopiesText');
            }
            return '';
        }
    }, {
        key: 'description',
        get: function get() {
            var holdsRatio = this.model.get('holdsRatio');
            var holdListPosition = this.model.get('holdListPosition') || 0;

            if (this.model.get('isPreReleaseTitle') && holdListPosition === 0) {
                return html('preReleaseModal.borrowUponRelease');
            }

            switch (this.type) {
                case 'ratio':
                    if (holdsRatio) {
                        return holdsRatio >= 1 ? html('holdsRatioHelpModal.listPositionHtml', { holdsRatio: this.model.get('holdsRatio') }) : html('holdsRatioHelpModal.nextAvailable');
                    }
                    return '';
                case 'basicPosition':
                case 'successPosition':
                case 'basic':
                default:
                    return '';
            }
        }
    }, {
        key: 'details',
        get: function get() {
            var holdsCount = this.model.get('holdsCount') || 0;
            var ownedCopies = this.model.get('ownedCopies') || 0;
            var holdListPosition = this.model.get('holdListPosition') || 0;
            switch (this.type) {
                case 'basicPosition':
                case 'successPosition':
                    return [html('holdsRatioHelpModal.yourHoldsPositionHtml', { holdListPosition: holdListPosition, holdsCount: holdsCount }), html('holdsRatioHelpModal.libraryCopies', { ownedCopies: ownedCopies })];
                case 'ratio':
                case 'basic':
                default:
                    return [html('holdsRatioHelpModal.totalHoldsHtml', { holdsCount: holdsCount }), html('holdsRatioHelpModal.libraryCopies', { ownedCopies: ownedCopies })];
            }
        }
    }, {
        key: 'note',
        get: function get() {
            return this.model.get('isFastlane') ? html('advantageFastPassHtml') : '';
        }
    }]);

    function HoldInformation(_ref) {
        var type = _ref.type;

        _classCallCheck(this, HoldInformation);

        var _this = _possibleConstructorReturn(this, (HoldInformation.__proto__ || Object.getPrototypeOf(HoldInformation)).apply(this, arguments));

        _this.el = _this.el || document.createElement('div');
        _this.el.className = _this.el.className + ' HoldInformation';
        _this.type = type || 'basic';
        return _this;
    }

    _createClass(HoldInformation, [{
        key: 'render',
        value: function render() {
            var view = (0, _HoldInformation2['default'])({
                expirationWarning: this.expirationWarning,
                description: this.description,
                details: this.details,
                note: this.note
            });
            this.$el.empty().append(view);

            return this;
        }
    }]);

    return HoldInformation;
}(Backbone.View);

exports['default'] = HoldInformation;

},{"../templates/HoldInformation.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\templates\\HoldInformation.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformationModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _HoldInformation = require('./HoldInformation');

var _HoldInformation2 = _interopRequireDefault(_HoldInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldInformationModal = function (_Modal) {
    _inherits(HoldInformationModal, _Modal);

    function HoldInformationModal(_ref) {
        var model = _ref.model,
            type = _ref.type;

        _classCallCheck(this, HoldInformationModal);

        var information = new _HoldInformation2['default']({ model: model, type: type }).render();
        var modalContents = {
            classes: ['HoldInformationModal'],
            title: window.html('holdsRatioHelpModal.heading'),
            content: information.el
        };
        return _possibleConstructorReturn(this, (HoldInformationModal.__proto__ || Object.getPrototypeOf(HoldInformationModal)).call(this, modalContents));
    }

    return HoldInformationModal;
}(_modal.Modal);

exports['default'] = HoldInformationModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./HoldInformation":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformation.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\ContextMenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContextMenu = require('./templates/ContextMenu.html');

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    featureManager = _window.featureManager,
    url = _window.url,
    routes = _window.routes,
    OverDrive = _window.OverDrive,
    text = _window.text,
    html = _window.html;

var ContextMenu = function (_Backbone$View) {
    _inherits(ContextMenu, _Backbone$View);

    function ContextMenu() {
        _classCallCheck(this, ContextMenu);

        var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).apply(this, arguments));

        _this.template = _ContextMenu2['default'];

        _this.isKeyboardSelectEvent = function (e) {
            return (e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        };

        _this.rid = Math.random().toString(36).substring(7);

        _this.listenTo(_this.model, 'change:isInHistory', function () {
            return _this.render();
        });

        _this.render();
        return _this;
    }
    // TODO: Go back and refactor out data tied to the DOM in the template -alance


    _createClass(ContextMenu, [{
        key: 'events',
        value: function events() {
            return {
                'click .js-historyAction': '_handleClick',
                'keydown .js-historyAction': '_handleKey',
                'keydown .js-context-button': 'toggle'
            };
        }
    }, {
        key: '_handleClick',
        value: function _handleClick() {
            this.model.trigger('title:action', { action: 'history', model: this.model });
        }
    }, {
        key: '_handleKey',
        value: function _handleKey(e) {
            e.stopImmediatePropagation();

            if (e.keyCode === 13 || e.keyCode === 32) {
                this.model.trigger('title:action', { action: 'history', model: this.model });
            }
        }
    }, {
        key: '_getSampleText',
        value: function _getSampleText() {
            var type = this.model.get('type').id;

            if (type === 'audiobook' || type === 'music') {
                return text('sampleListen');
            } else if (type === 'video') {
                return text('sampleWatch');
            }

            return text('sampleRead');
        }
    }, {
        key: '_getHistoryActionLabel',
        value: function _getHistoryActionLabel() {
            var title = this.model.get('title');
            if (this.model.get('isInHistory')) {
                return html('readingHistory.removeTitle', { title: title });
            } else {
                return html('readingHistory.addTitle', { title: title });
            }
        }
    }, {
        key: '_getHistoryActionText',
        value: function _getHistoryActionText() {
            if (this.model.get('isInHistory')) {
                return html('readingHistory.remove');
            } else {
                return html('readingHistory.add');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.$el.empty().append(this.template(this.viewModel));

            return this;
        }
    }, {
        key: 'toggle',
        value: function toggle(e) {
            if (this.isKeyboardSelectEvent(e)) {
                window.Foundation.libs.dropdown.toggle(this.$el.find('.js-context-button'));
            }
        }
    }, {
        key: 'viewModel',
        get: function get() {
            var seriesSearchUrl = '';
            if (featureManager.isEnabled('enhancedSeries') && this.model.get('detailedSeries')) {
                seriesSearchUrl = url(routes.searchByType, { type: 'seriesId', query: this.model.get('detailedSeries').seriesId, sortBy: 'readingOrder' });
            } else if (this.model.get('series')) {
                seriesSearchUrl = url(routes.searchByType, { type: 'series', query: this.model.get('series'), sortBy: 'newlyadded' });
            }

            return {
                id: this.model.id,
                rid: this.rid,
                title: this.model.get('title'),
                typeId: this.model.get('type').id,
                sampleHref: this.model.get('sample').href || '',
                sampleText: this._getSampleText(),
                alignment: 'bottom',
                historyActionLabel: this._getHistoryActionLabel(),
                historyActionText: this._getHistoryActionText(),
                historyEnabled: OverDrive.showHistoryFeature && !this.model.get('isPreReleaseTitle'),
                gaHistoryAction: this.model.get('isInHistory') ? 'history-remove' : 'history-add',
                seriesSearchUrl: seriesSearchUrl
            };
        }
    }]);

    return ContextMenu;
}(Backbone.View);

exports['default'] = ContextMenu;

},{"./templates/ContextMenu.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\ContextMenu.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Cover = require('./templates/Cover.html');

var _Cover2 = _interopRequireDefault(_Cover);

var _NoCover = require('./templates/NoCover.html');

var _NoCover2 = _interopRequireDefault(_NoCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    Logger = _window.Logger;

var Cover = function (_Backbone$View) {
    _inherits(Cover, _Backbone$View);

    function Cover(_ref) {
        var coverWidths = _ref.coverWidths,
            isInHero = _ref.isInHero,
            _ref$isTitleHistory = _ref.isTitleHistory,
            isTitleHistory = _ref$isTitleHistory === undefined ? false : _ref$isTitleHistory;

        _classCallCheck(this, Cover);

        var _this = _possibleConstructorReturn(this, (Cover.__proto__ || Object.getPrototypeOf(Cover)).apply(this, arguments));

        _this.coverWidths = _.extend({ mobile: 145, tablet: 160, desktop: 190 }, coverWidths);
        _this.isInHero = isInHero;
        _this.isTitleHistory = isTitleHistory;

        _this.listenTo(_this.model, 'change', _this._render);
        _this._render();
        return _this;
    }

    _createClass(Cover, [{
        key: 'remove',
        value: function remove() {
            $(window).off('resize.' + this.model.id);
        }
    }, {
        key: '_render',
        value: function _render() {
            var _this2 = this;

            var media = this.model.toJSON();

            var device = detectshun.browser();
            var coverWidth = device.mobile ? this.coverWidths.mobile : device.tablet ? this.coverWidths.tablet : this.coverWidths.desktop;
            var cover = this.model.getCover(coverWidth);

            if (this.model.isPlaceholder) {
                var $cover = '<div class="CoverImageContainer"></div>';
                this.$el.empty().append($cover);
            } else if (cover && cover.href) {
                var _$cover = $((0, _Cover2['default'])({
                    media: media,
                    coverColor: cover && cover.primaryColor && cover.primaryColor.hex || 'inherit',
                    src: cover && cover.href,
                    href: this.model.titleDetailsUrl,
                    label: window.text('cover.coverImageLabel', { title: media.title, creator: media.firstCreatorName }),
                    noSampleClass: media.sample.href == null ? 'is-noSample' : ''
                }));

                // LHTNG-2105: In the event that an image fails to load, wipe out the href's and update the model to trigger a render()
                _$cover.find('img').on('error', function () {

                    // LHTNG-2143
                    Logger && Logger.log('error', 'CDN Error', {
                        type: 'image',
                        titleId: media.id,
                        src: cover && cover.href
                    });

                    var imagesRemoved = JSON.parse(JSON.stringify(_this2.model.attributes.covers));

                    _(imagesRemoved).each(function (image) {
                        delete image.href;
                    });

                    _this2.model.set({ covers: imagesRemoved });
                });

                this.$el.empty().append(_$cover);
            } else if (this.isTitleHistory) {
                this.$el.empty().append('<a href="' + this.model.titleDetailsUrl + '">\n                    <img alt="' + window.html('coverImageForTitle', { title: media.title }) + '" class="history-noCover" src="/public/img/no-cover_en_US.jpg">\n                </a>');
            } else {

                var creatorText = this.model.isMagazine ? this.model.get('edition') : this.model.get('firstCreatorName');
                this.$el.empty().append((0, _NoCover2['default'])({
                    media: media,
                    href: this.model.titleDetailsUrl,
                    isInHero: this.isInHero,
                    coverWidth: coverWidth,
                    coverHeight: coverWidth * 293 / 220,
                    creatorText: creatorText
                }));
                $(window).on('resize.' + this.model.id, _.bind(this._manageOverflow, this, '.CoverImageContainer .noCoverAvailable .title', this.model.get('title')));
                $(window).on('resize.' + this.model.id, _.bind(this._manageOverflow, this, '.CoverImageContainer .noCoverAvailable .author', creatorText));
                $(window).on('resize.' + this.model.id, _.bind(this._resizeClearImage, this));

                // timeout gives browser chance to draw and set innerHTML values used
                setTimeout(function () {
                    _this2._manageOverflow('.CoverImageContainer .noCoverAvailable .title', _this2.model.get('title'));
                    _this2._manageOverflow('.CoverImageContainer .noCoverAvailable .author', creatorText);
                    _this2._resizeClearImage();
                }, 1);
            }

            return this;
        }
    }, {
        key: '_resizeClearImage',
        value: function _resizeClearImage() {
            var image = this.el.querySelector('img');
            if (image) {
                $(image).height($(image).parent().width() * 293 / 220);
            }
        }
    }, {
        key: '_manageOverflow',
        value: function _manageOverflow(selector, resetText) {
            var element = this.el.querySelector(selector);
            if (element) {
                element.innerHTML = resetText;
                if (selector.indexOf('.title') !== -1) {
                    if ($(element).width() < 100) {
                        $(element).css('font-size', '14px');
                    } else if ($(element).width() < 125 && $(element).width() >= 100) {
                        $(element).css('font-size', '16px');
                    } else if ($(element).width() < 150 && $(element).width() >= 125) {
                        $(element).css('font-size', '18px');
                    } else if ($(element).width() >= 150) {
                        $(element).css('font-size', '20px');
                    }
                } else if (selector.indexOf('.author') !== -1) {
                    if ($(element).width() < 110) {
                        $(element).css('font-size', '10px');
                    } else if ($(element).width() < 135 && $(element).width() >= 110) {
                        $(element).css('font-size', '12px');
                    } else if ($(element).width() < 160 && $(element).width() >= 135) {
                        $(element).css('font-size', '14px');
                    } else if ($(element).width() >= 160) {
                        $(element).css('font-size', '16px');
                    }
                }
                if (element.scrollHeight > 0 && element.scrollHeight > element.clientHeight) {
                    var text = element.innerHTML;
                    text = text.replace(/\W+$/g, '') + '...'; // remove trailing special characters and add ellipsis
                    while (text !== '...' && element.scrollHeight > element.clientHeight) {
                        text = text.replace(/\W*\w\W*(\.{3})$/g, '$1'); // remove a non-ellipsis character and unwanted characters around itΩ
                        element.innerHTML = text;
                    }
                    // todo: put a min width an height on this! We know what the heights are for particular screen widths
                }
            }
        }
    }]);

    return Cover;
}(Backbone.View);

exports['default'] = Cover;

},{"./templates/Cover.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\Cover.html.js","./templates/NoCover.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\NoCover.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MediaParameters = require('../../../../models/dao/MediaParameters');

var _MediaParameters2 = _interopRequireDefault(_MediaParameters);

var _TitleCollection = require('./models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaInterface = function () {
    function MediaInterface() {
        _classCallCheck(this, MediaInterface);

        _.extend(this, Backbone.Events);

        this.items = new _TitleCollection2['default']();
        this.facets = {};
        this.sortOptions = [];
    }

    _createClass(MediaInterface, [{
        key: 'quickSearch',
        value: function quickSearch(term, options) {
            return this._fetch(_.extend({}, { query: term }, options));
        }
    }, {
        key: 'search',
        value: function search(parameters, options) {
            return this._fetch(_.extend({}, parameters, options));
        }
    }, {
        key: 'fetchCollectionById',
        value: function fetchCollectionById(id, options) {
            return this._fetch(_.extend({}, { collectionId: id }, options));
        }
    }, {
        key: 'fetchCollectionByParameters',
        value: function fetchCollectionByParameters(collectionFilters, options) {
            return this._fetch(_.extend({}, collectionFilters, options));
        }

        /** Utility function to simulate a data call, but deliberatley return an empty result set */

    }, {
        key: 'fetchEmptyResponse',
        value: function fetchEmptyResponse() {
            this.trigger('sync:start', this, { mediaParameters: null });

            var emptyResponse = {
                items: [],
                facets: {},
                sortOptions: []
            };

            this._fetchDone(emptyResponse, 'synthetic');

            this.trigger('sync:end', this);

            return Promise.resolve(emptyResponse);
        }

        /**
         * @param {MediaParameters} parameters
         * @memberof MediaInterface
         */

    }, {
        key: '_fetch',
        value: function _fetch(parameters) {
            var _this = this;

            if (!parameters) {
                parameters = {};
            }

            // if a title id is specificed then no facets will be calculated regardless of the params sent.
            if (!parameters.includedFacets && !parameters.titleId) {
                parameters.includedFacets = window.OverDrive.supportedFacets;
            }

            if (window.featureManager.isEnabled('LuckyDay') && parameters.shuffle) {
                var sorts = ['mostpopular', 'releasedate', 'title', 'author', 'newlyadded', 'lowcirculating', 'mostpopular-site'];
                parameters.sortBy = sorts[Math.floor(Math.random() * sorts.length)];
            }

            var mediaParameters = new _MediaParameters2['default'](parameters);

            if (!!window.OverDrive.showOnlyAvailable) {
                mediaParameters.showOnlyAvailable = true;
            }

            this.trigger('sync:start', this, { mediaParameters: mediaParameters });

            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: window.url(window.routes.rest.media.index),
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(mediaParameters.serialize()),
                    timeout: 10000
                }).done(function (data, textStatus, jqXHR) {
                    if (window.featureManager.isEnabled('LuckyDay') && parameters.shuffle) {
                        data.items = data.items && _.shuffle(data.items);
                    }
                    _this._fetchDone(data, textStatus, jqXHR);
                    _this.trigger('sync:end', _this);
                    resolve(data);
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    _this._fetchFail(jqXHR, textStatus, errorThrown);
                    _this.trigger('sync:end', _this);
                    reject(jqXHR);
                });
            });
        }
    }, {
        key: '_fetchDone',
        value: function _fetchDone(data, textStatus, jqXHR) {
            this.items.reset(data.items);
            this.trigger('sync:success', this, { data: data, textStatus: textStatus, jqXHR: jqXHR });
        }
    }, {
        key: '_fetchFail',
        value: function _fetchFail(jqXHR, textStatus, errorThrown) {
            this.trigger('sync:fail', this, { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
        }
    }]);

    return MediaInterface;
}();

exports['default'] = MediaInterface;

},{"../../../../models/dao/MediaParameters":"C:\\projects\\lightning\\models\\dao\\MediaParameters.js","./models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleActionButton = function (_Backbone$View) {
    _inherits(TitleActionButton, _Backbone$View);

    function TitleActionButton(_ref) {
        var _ref$type = _ref.type,
            type = _ref$type === undefined ? 'link' : _ref$type,
            action = _ref.action,
            style = _ref.style;

        _classCallCheck(this, TitleActionButton);

        var _this = _possibleConstructorReturn(this, (TitleActionButton.__proto__ || Object.getPrototypeOf(TitleActionButton)).apply(this, arguments));

        _this.isSelectEvent = function (e) {
            return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        };

        _this.type = type;

        _this.hasCustomAction = false;
        if (!!action) {
            _this.action = action;
            _this.hasCustomAction = true;
        }

        _this.style = style;

        _this.$button = $('<button />');

        _this.listenTo(_this.model, 'change:titleState', _this.render);

        _this.render();
        return _this;
    }

    _createClass(TitleActionButton, [{
        key: 'render',
        value: function render() {
            this.$button.off();
            this.$el.off();

            var attributes = this.getButtonAttrs();
            if (_(attributes.href).isEmpty()) {
                this.$button = $('<button />', attributes);
            } else {
                this.$button = $('<a />', attributes);
            }

            // Attach event handlers if either is true
            // - Button is not a link
            // - Custom action has been provided
            if (_(attributes.href).isEmpty() || this.hasCustomAction) {
                this._attachEventHandlers(this.$button);
            }

            this.$el.empty().append(this.$button);

            return this;
        }
    }, {
        key: 'waiting',
        value: function waiting() {
            var isWaiting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (isWaiting) {
                this.$button.off('.titleActionButton').addClass('waiting').attr('disabled', isWaiting).append('<div class="spinner"></div>');
            } else {
                this.$button.removeClass('waiting').attr('disabled', isWaiting).find('.spinner').remove();

                this._attachEventHandlers(this.$button);
            }

            return this;
        }
    }, {
        key: '_attachEventHandlers',
        value: function _attachEventHandlers($el) {
            var _this2 = this;

            $el.off('.titleActionButton');

            $el.on('click.titleActionButton', function (e) {
                _this2.isSelectEvent(e) && _this2.action(e);
            });
            $el.on('keydown.titleActionButton', function (e) {
                _this2.isSelectEvent(e) && _this2.action(e);
            });
        }
    }, {
        key: 'action',
        value: function action(event) {
            this.isSelectEvent(event) && this._triggerTitleAction();
        }
    }, {
        key: '_triggerTitleAction',
        value: function _triggerTitleAction() {
            this.model.trigger('title:action', { action: this.state, model: this.model });
        }
    }, {
        key: 'getButtonAttrs',
        value: function getButtonAttrs() {
            var buttonAttrs = {
                'data-media-id': this.model.id,
                'data-type': this.model.attributes.type.id,
                'data-type-name': this.model.attributes.type.id && window.html(this.model.attributes.type.id) || '',
                html: this.$button.html && this.$button.html() || '',
                tabindex: 0
            };

            var title = this.model.attributes.title;

            var classes = ['TitleActionButton', 'u-allCaps'];

            if (this.isButton) {
                var _classes;

                (_classes = classes).push.apply(_classes, ['button', 'radius', 'is-button', 'secondary']);
            }

            if (this.style === 'fill') {
                classes.push('fill');
            }

            switch (this.state) {
                case 'recommend':
                    classes.push('is-recommend');
                    if (this.isLink) {
                        classes.push('secondary-color');
                    }
                    buttonAttrs.html = '<span>' + window.html('recommend') + '</span>';
                    buttonAttrs['aria-label'] = window.html('recommendTitle', { title: title });
                    break;
                case 'recommended':
                    if (this.isButton) {
                        classes.push('outline gray');
                        classes = _(classes).without('secondary');
                    }

                    classes.push('is-recommended');
                    buttonAttrs.html = '<span>' + window.html('recommended') + '</span>';
                    buttonAttrs.href = window.url(window.routes.accountRecommendations);
                    break;
                case 'unavailable':
                    classes.push('is-unavailable js-unavailable disabled');
                    buttonAttrs.html = '<span>' + window.html('availabilityUnavailable') + '</span>';
                    break;
                case 'nook':
                    classes.push('is-nook js-nook');
                    buttonAttrs.html = '<span>' + window.html('sendToNook') + '</span>';
                    break;
                case 'preview':
                    if (this.isLink) {
                        classes.push('secondary-color');
                    }

                    classes.push('is-preview js-preview secondary');
                    buttonAttrs.html = '<span>' + window.html('demoMode.preview') + '</span>';
                    buttonAttrs['aria-label'] = window.html('demoMode.previewTitle', { title: title });
                    break;
                case 'borrow':
                    if (this.isLink) {
                        classes.push('secondary-color');
                    }

                    classes.push('is-borrow js-borrow secondary');
                    buttonAttrs.html = '<span>' + window.html('borrow') + '</span>';
                    buttonAttrs['aria-label'] = window.html('borrowTitle', { title: title });
                    break;
                case 'borrowed':
                    classes.push('is-borrowed js-borrowed');
                    buttonAttrs.html = '<span>' + window.html('goToLoans') + '</span>';
                    buttonAttrs.href = window.url(window.routes.accountLoans);
                    break;
                case 'hold':
                    if (this.isLink) {
                        classes.push('secondary-color-hover');
                    }

                    classes.push('is-hold js-hold');
                    buttonAttrs.html = '<span>' + window.html('placeAHold') + '</span>';
                    buttonAttrs['aria-label'] = window.html('placeAHoldOnTitle', { title: title });
                    break;
                case 'onHold':
                    if (this.isButton) {
                        classes.push('primary');
                    }

                    classes.push('is-onHold js-onHold');
                    buttonAttrs.html = '<span>' + window.html('goToHolds') + '</span>';
                    buttonAttrs.href = window.url(window.routes.accountHolds);
                    break;
                case 'renew':
                    classes.push('is-renew renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('renewal.renewTitle', { title: '' }) + '</span>';
                    break;
                case 'requestAgain':
                    classes.push('is-requestAgain renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('accountLoans.requestAgain') + '</span>';
                    break;
                case 'requested':
                    classes.push('is-requested renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('accountLoans.requested') + '</span>';
                    break;
                case 'renewed':
                    classes.push('is-renewed renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('accountLoans.renewed') + '</span>';
                    break;
                case 'listenNow':
                    classes.push('is-listenNow');
                    buttonAttrs.html = '<span>' + window.html('listenNow') + '</span>';
                    buttonAttrs.href = window.url(window.routes.mediaDownload, { format: 'audiobook-overdrive', mediaId: this.model.id });
                    buttonAttrs.target = '_blank';
                    break;
                case 'readNow':
                    classes.push('is-readNow');
                    buttonAttrs.html = '<span>' + window.html('readNow') + '</span>';
                    buttonAttrs.href = window.url(window.routes.mediaDownload, { format: 'ebook-overdrive', mediaId: this.model.id });
                    buttonAttrs.target = '_blank';
                    break;
                case 'addToApp':
                    if (this.isLink) {
                        classes.push('secondary-color-hover');
                    }

                    classes.push('is-addToApp');
                    buttonAttrs.html = '<span>' + window.html('addToApp') + '</span>';
                    buttonAttrs.href = window.url(window.routes.mediaDownload, { format: this.model.get('addToAppFormat'), mediaId: this.model.id });
                    break;
                case 'waiting':
                    if (this.isLink) {
                        var dotSpinner = $(window.primaryActionLoadingGif);
                        dotSpinner.css('width', 'inherit');
                        buttonAttrs.html = dotSpinner;
                        break;
                    }

                    classes.push('waiting secondary');
                    buttonAttrs.disabled = true;
                    buttonAttrs.html = '<span>working</span><div class="spinner"></div>';
                    break;
            }

            buttonAttrs['class'] = classes.join(' ');

            return buttonAttrs;
        }
    }, {
        key: 'isButton',
        get: function get() {
            return this.type === 'button';
        }
    }, {
        key: 'isLink',
        get: function get() {
            return this.type === 'link';
        }
    }, {
        key: 'state',
        get: function get() {
            return this.model.get('titleState');
        }
    }]);

    return TitleActionButton;
}(Backbone.View);

exports['default'] = TitleActionButton;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleCard = require('./templates/TitleCard.html');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleInfo = require('./views/TitleInfo');

var _TitleInfo2 = _interopRequireDefault(_TitleInfo);

var _TitleActionButton = require('./TitleActionButton');

var _TitleActionButton2 = _interopRequireDefault(_TitleActionButton);

var _WishListButton = require('./WishListButton');

var _WishListButton2 = _interopRequireDefault(_WishListButton);

var _TitleHeaderBar = require('./TitleHeaderBar');

var _TitleHeaderBar2 = _interopRequireDefault(_TitleHeaderBar);

var _Cover = require('./Cover');

var _Cover2 = _interopRequireDefault(_Cover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleCard = function (_Backbone$View) {
    _inherits(TitleCard, _Backbone$View);

    _createClass(TitleCard, [{
        key: 'className',
        get: function get() {
            return 'title-container title';
        }
    }]);

    function TitleCard(_ref) {
        var coverWidths = _ref.coverWidths,
            _ref$isInHero = _ref.isInHero,
            isInHero = _ref$isInHero === undefined ? false : _ref$isInHero;

        _classCallCheck(this, TitleCard);

        var _this = _possibleConstructorReturn(this, (TitleCard.__proto__ || Object.getPrototypeOf(TitleCard)).apply(this, arguments));

        _this.template = _TitleCard2['default'];

        _this._views = [];

        _this.coverWidths = coverWidths;
        _this.isInHero = isInHero;

        _this.render();
        return _this;
    }

    _createClass(TitleCard, [{
        key: 'render',
        value: function render() {
            var model = this.model,
                coverWidths = this.coverWidths,
                isInHero = this.isInHero;


            this.$el.empty();

            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];

            var $tmp = $(this.template());

            // TODO: This will not work  with CSS transition animations
            if (this.model.isPlaceholder) {
                this.$el.addClass('placeholder');
            }

            this._views.push(this.titleHeaderBar = new _TitleHeaderBar2['default']({
                model: model, el: $tmp.find('.TitleHeaderBar')
            }));

            this._views.push(this.cover = new _Cover2['default']({
                model: model, el: $tmp.find('.CoverImage'), coverWidths: coverWidths, isInHero: isInHero
            }));

            this._views.push(this.titleInfo = new _TitleInfo2['default']({
                model: model, el: $tmp.find('.TitleInfo')
            }));

            this._views.push(this.titleActionButton = new _TitleActionButton2['default']({
                model: model, el: $tmp.find('.TitleAction')
            }));

            if (!window.featureManager.isEnabled('internationalDemoMode')) {
                this._views.push(this.wishlistButton = new _WishListButton2['default']({
                    model: model, el: $tmp.find('.TitleWishlist'), type: 'icon-only'
                }).render());
            }

            this.$el.append($tmp);

            return this;
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            _get(TitleCard.prototype.__proto__ || Object.getPrototypeOf(TitleCard.prototype), 'remove', this).call(this);
        }
    }]);

    return TitleCard;
}(Backbone.View);

exports['default'] = TitleCard;

},{"./Cover":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js","./TitleActionButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js","./TitleHeaderBar":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleHeaderBar.js","./WishListButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\WishListButton.js","./templates/TitleCard.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleCard.html.js","./views/TitleInfo":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCardListView.js":[function(require,module,exports){
'use strict';

var _TitleInfoListView = require('./views/TitleInfoListView');

var _TitleInfoListView2 = _interopRequireDefault(_TitleInfoListView);

var _TitleActionButton = require('./TitleActionButton');

var _TitleActionButton2 = _interopRequireDefault(_TitleActionButton);

var _WishListButton = require('./WishListButton');

var _WishListButton2 = _interopRequireDefault(_WishListButton);

var _TitleHeaderBar = require('./TitleHeaderBar');

var _TitleHeaderBar2 = _interopRequireDefault(_TitleHeaderBar);

var _Cover = require('./Cover');

var _Cover2 = _interopRequireDefault(_Cover);

var _TitleDescription = require('./views/TitleDescription.js');

var _TitleDescription2 = _interopRequireDefault(_TitleDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Backbone = window.Backbone;


var path = require('path');
var TitleCardTemplate = "<div class=\"title-contents card\">    \n    <div class=\"title TitleCard\">\n        <div class=\"TitleHeaderBar\"></div>\n        <div class=\"CoverImage\"></div>\n    </div>\n\n    <div class=\"TitleInfo\"></div>\n\n    <div class=\"row\">\n        <div class=\"columns small-12\">\n            <div class=\"title-description\"></div>\n        </div>\n    </div>\n\n    <div class=\"action-buttons list-view\">\n        <div class=\"TitleAction\"></div>\n        <div class=\"TitleWishlist is-full\"></div>\n    </div>\n</div>\n";

var TitleCardListView = Backbone.View.extend({

    className: 'title-container',

    template: _.template(TitleCardTemplate),

    initialize: function initialize(_ref) {
        var bus = _ref.bus,
            coverWidths = _ref.coverWidths;

        var model = this.model;

        var $tmp = $(this.template());

        this.titleHeaderBar = new _TitleHeaderBar2['default']({
            model: model, el: $tmp.find('.TitleHeaderBar')
        });

        this.cover = new _Cover2['default']({
            model: model, el: $tmp.find('.CoverImage'), coverWidths: coverWidths, isInHero: false
        });

        this.titleInfo = new _TitleInfoListView2['default']({
            model: model, el: $tmp.find('.TitleInfo')
        });

        this.titleActionButton = new _TitleActionButton2['default']({
            model: model, el: $tmp.find('.TitleAction'), type: 'button', style: 'fill'
        });

        if (!window.featureManager.isEnabled('internationalDemoMode')) {
            this.wishlistButton = new _WishListButton2['default']({
                model: model, el: $tmp.find('.TitleWishlist'), type: 'with-text'
            }).render();
        }

        this.titleDescription = new _TitleDescription2['default']({
            model: model, el: $tmp.find('.title-description')
        });

        this.$el.html($tmp);
    }
});

module.exports = TitleCardListView;


},{"./Cover":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js","./TitleActionButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js","./TitleHeaderBar":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleHeaderBar.js","./WishListButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\WishListButton.js","./views/TitleDescription.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleDescription.js","./views/TitleInfoListView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfoListView.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _processForwardedAction = require('../../util/title-actions/processForwardedAction');

var _processForwardedAction2 = _interopRequireDefault(_processForwardedAction);

var _HashManager = require('../../components/common/HashManager');

var _HashManager2 = _interopRequireDefault(_HashManager);

var _TitleCard = require('./TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleActions = require('../../title-actions/TitleActions');

var _TitleActions2 = _interopRequireDefault(_TitleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var he = require('he');
// This assumes that the calling code passes a Backbone.Collection with a model type of Title

var TitleCollectionView = function (_Backbone$View) {
    _inherits(TitleCollectionView, _Backbone$View);

    function TitleCollectionView(_ref) {
        var bus = _ref.bus,
            patronMediaItemsModel = _ref.patronMediaItemsModel,
            View = _ref.View,
            attributes = _ref.attributes,
            coverWidths = _ref.coverWidths,
            isInHero = _ref.isInHero,
            context = _ref.context;

        _classCallCheck(this, TitleCollectionView);

        var _this = _possibleConstructorReturn(this, (TitleCollectionView.__proto__ || Object.getPrototypeOf(TitleCollectionView)).apply(this, arguments));

        _this._views = [];

        _this.bus = bus;
        _this.View = View || _TitleCard2['default'];
        _this.attributes = _.extend({}, attributes);
        _this.coverWidths = coverWidths;
        _this.isInHero = isInHero;
        _this.context = context;

        _this.titleActions = new _TitleActions2['default']({ bus: _this.bus, context: context });

        _this.listenTo(_this.collection, 'title:action', _this._handleTitleAction);

        // TODO: >>> Remove this call and _updateMediaStates() logic and update dependant consumers to use PatronTitleStatus
        // Fetch patron data and trigger state updates.
        // Only fetch patron data if authed and has linked cards.
        if (patronMediaItemsModel && window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
            patronMediaItemsModel.initialFetch().then(function (patronData) {
                _this._updateMediaStates(patronData);
            });
        }

        _this.render();
        return _this;
    }

    _createClass(TitleCollectionView, [{
        key: '_handleTitleAction',
        value: function _handleTitleAction(_ref2) {
            var action = _ref2.action,
                model = _ref2.model;

            this.titleActions.perform(action, model);
        }
    }, {
        key: '_updateMediaStates',
        value: function _updateMediaStates(patronData) {
            var _this2 = this;

            var ids = [];
            _(_.values(patronData)).each(function (item) {
                if (_.isArray(item)) {
                    var _ids;

                    (_ids = ids).push.apply(_ids, _toConsumableArray(item));
                } else if (_.isObject(item)) {
                    var _ids2;

                    (_ids2 = ids).push.apply(_ids2, _toConsumableArray(_.keys(item).map(Number)));
                } else {
                    ids.push(item);
                }
            });
            ids = _.uniq(ids);

            ids.forEach(function (id) {
                var model = _this2.collection.get(id);

                if (model) {
                    model.updatePatronState(patronData);
                }
            });

            this._performForwardedAction();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var frag = document.createDocumentFragment();

            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];

            this.collection.forEach(function (title) {

                title.set('title', he.decode(title.get('title')));

                title.setContext(_this3.context);

                var view = new _this3.View({
                    model: title,
                    bus: _this3.bus,
                    coverWidths: _this3.coverWidths,
                    isInHero: _this3.isInHero
                });

                frag.appendChild($('<li />', {
                    'class': 'js-titleCard Item'
                }).append(view.$el)[0]);

                _this3._views.push(view);
            });

            // TODO: Figure out a better way to handle the collection title
            var $collectionTitle = $('.collection-title-container');

            this.$el.attr(this.attributes);
            this.$el.empty().append($collectionTitle).append(frag);
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            _get(TitleCollectionView.prototype.__proto__ || Object.getPrototypeOf(TitleCollectionView.prototype), 'remove', this).call(this);
        }
    }, {
        key: '_performForwardedAction',
        value: function _performForwardedAction() {
            if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards && _HashManager2['default'].get('action')) {
                var forwardedAction = new _processForwardedAction2['default'](this.collection, this.bus);
                forwardedAction.executeAction();
                window.forwardedAction = forwardedAction;
            }
        }
    }, {
        key: 'tagName',
        get: function get() {
            return 'ul';
        }
    }]);

    return TitleCollectionView;
}(Backbone.View);

exports['default'] = TitleCollectionView;

},{"../../components/common/HashManager":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js","../../title-actions/TitleActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js","../../util/title-actions/processForwardedAction":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processForwardedAction.js","./TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","he":"C:\\projects\\lightning\\node_modules\\he\\he.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleHeaderBar.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Backbone = window.Backbone;

var TitleHeaderBar = Backbone.View.extend({
    initialize: function initialize() {
        this.listenTo(this.model, 'change', this.render);

        this.$titleHeaderBar = $('<div />');

        this.render();
    },
    render: function render() {
        var a = this.returnState();

        this.$titleHeaderBar = $('<div />', a.container).append($('<a />', a.link));
        this.$el.html(this.$titleHeaderBar);
        this.$el.attr('aria-hidden', 'true');

        return this;
    },
    returnState: function returnState() {
        var banner = {
            container: {
                classes: ['title-header-bar', 'u-allCaps']
            },
            link: {
                text: '',
                href: this.model.titleDetailsUrl,
                tabindex: -1
            }
        };

        this.action = this.model.get('titleState');

        switch (this.action) {
            case 'recommend':
                banner.container.classes.push('is-recommend not-owned-title');
                banner.link.text = window.html('availabilityNotOwned');
                break;
            case 'recommended':
                banner.container.classes.push('is-recommended not-owned-title');
                banner.link.text = window.html('recommended');
                break;
            case 'unavailable':
                banner.container.classes.push('is-unavailable unavailable-title');
                banner.link.text = window.html('availabilityUnavailable');
                break;
            case 'nook':
                banner.container.classes.push('is-nook available-title secondary-background');
                banner.link.text = window.html('availabilityAvailable');
                break;
            case 'borrow':
                banner.container.classes.push('available-title secondary-background is-borrow');
                banner.link.text = window.html('availabilityAvailable');
                break;
            case 'borrowed':
            case 'addToApp':
            case 'listenNow':
            case 'readNow':
                banner.container.classes.push('is-borrowed available-title secondary-background');
                banner.link.text = window.html('borrowed');
                break;
            case 'hold':
                banner.container.classes.push('is-hold unavailable-title');
                banner.link.text = this.model.get('isPreReleaseTitle') ? window.html('availabilityComingSoon') : window.text('availabilityWaitList');
                break;
            case 'onHold':
                banner.container.classes.push('is-onHold unavailable-title');
                banner.link.text = window.html('onHold');
                break;
            case 'waiting':
                banner.container.classes = this.$titleHeaderBar.attr('class').split(' ');
                banner.link.text = this.$titleHeaderBar.find('a:first').text();
                break;
        }

        banner.container['class'] = banner.container.classes.join(' ');

        return banner;
    }
});

exports['default'] = TitleHeaderBar;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\WishListButton.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WishListButton = require('./templates/WishListButton.html');

var _WishListButton2 = _interopRequireDefault(_WishListButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WishListButton = function (_Backbone$View) {
    _inherits(WishListButton, _Backbone$View);

    _createClass(WishListButton, [{
        key: 'contrastClass',
        get: function get() {
            return this.contrast === 'default' ? '' : 'contrast-alternate';
        }
    }, {
        key: 'ariaLabel',
        get: function get() {
            var title = this.model.attributes.title;
            return this.model.get('wishlistState') === 'wishlistAdd' ? window.html('addTitleToWishList', { title: title }) : window.html('removeTitleFromWishList', { title: title });
        }
    }, {
        key: 'iconClass',
        get: function get() {
            return this.model.get('wishlistState') === 'wishlistAdd' ? 'icon-wish-list' : 'icon-wish-list-added';
        }
    }, {
        key: 'text',
        get: function get() {
            if (this.type === 'icon-only') {
                return '';
            }
            return this.model.get('wishlistState') === 'wishlistAdd' ? window.html('addToWishList') : window.html('removeFromWishList');
        }
    }, {
        key: 'ga',
        get: function get() {
            var isAdd = this.model.get('wishlistState') === 'wishlistAdd';
            if (isAdd) {
                return {
                    mediaId: this.model.attributes.id,
                    formatType: this.model.attributes.type.id
                };
            }
            return null;
        }
    }]);

    function WishListButton(_ref) {
        var type = _ref.type,
            contrast = _ref.contrast;

        _classCallCheck(this, WishListButton);

        var _this = _possibleConstructorReturn(this, (WishListButton.__proto__ || Object.getPrototypeOf(WishListButton)).apply(this, arguments));

        _this.type = type || 'icon-only';
        _this.contrast = contrast || 'default';

        _this.listenTo(_this.model, 'change:wishlistState', _this.render);
        _this.type = type || 'icon-only';
        return _this;
    }

    _createClass(WishListButton, [{
        key: 'events',
        value: function events() {
            return { 'click': '_handleClick' };
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.el || this.$el.length < 1) {
                return; // we have no target to render anything into
            }

            // retain focus on rerender
            var needsRefocus = this.el.querySelector('.WishListButton') === document.activeElement;

            this.$el.empty();

            // LHTNG-1648 - Dont render wishlist icon on recommend* state titles
            if (_(['recommend', 'recommended']).contains(this.model.get('titleState'))) {
                return this;
            }

            var buttonHtml = (0, _WishListButton2['default'])({
                ga: this.ga,
                contrastClass: this.contrastClass,
                ariaLabel: this.ariaLabel,
                iconClass: this.iconClass,
                text: this.text
            });

            this.$el.append(buttonHtml);

            if (needsRefocus) {
                this.el.querySelector('.WishListButton').focus();
            }

            return this;
        }
    }, {
        key: '_handleClick',
        value: function _handleClick() {
            this.model.trigger('title:action', { action: 'wish', model: this.model });
            this._animate();
        }
    }, {
        key: '_animate',
        value: function _animate() {
            this.$el.find('i').removeClass('animated bounceIn bounceOut').addClass('animated bounceOut');
        }
    }]);

    return WishListButton;
}(Backbone.View);

exports['default'] = WishListButton;

},{"./templates/WishListButton.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\WishListButton.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\MediaViewPreference.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaViewPreference = function (_Backbone$Model) {
    _inherits(MediaViewPreference, _Backbone$Model);

    function MediaViewPreference(params) {
        _classCallCheck(this, MediaViewPreference);

        var _this = _possibleConstructorReturn(this, (MediaViewPreference.__proto__ || Object.getPrototypeOf(MediaViewPreference)).call(this, params));

        _this.defaults = {
            view: MediaViewPreference.options.grid
        };


        _this.set({
            view: Cookies.get('media-view-preference') || MediaViewPreference.options.grid
        });

        _this.listenTo(_this, 'change:view', function (model, value) {
            Cookies.set('media-view-preference', value, { httpOnly: false, expires: 365 });
        });
        return _this;
    }

    return MediaViewPreference;
}(Backbone.Model);

MediaViewPreference.options = {
    grid: 'grid',
    list: 'list'
};
exports['default'] = MediaViewPreference;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleState = require('../../../title-actions/TitleState');

var _TitleState2 = _interopRequireDefault(_TitleState);

var _MediaInterface = require('../MediaInterface');

var _MediaInterface2 = _interopRequireDefault(_MediaInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Title = function (_Backbone$Model) {
    _inherits(Title, _Backbone$Model);

    _createClass(Title, [{
        key: 'defaults',
        value: function defaults() {
            return {
                id: 0,
                firstCreatorName: 'Author',
                title: 'Title',
                firstCreatorId: 0,
                formats: [],
                isOwned: false,
                isHoldable: false,
                isRecommendableToLibrary: false,
                isPreReleaseTitle: false,
                isAvailable: false,
                starRating: 0.0,
                userStarRating: 0,
                starRatingCount: 0,
                holdsRatio: 0,
                holdsCount: 0,
                ownedCopies: 0,
                availableCopies: 0,
                luckyDayOwnedCopies: 0,
                luckyDayAvailableCopies: 0,
                estimatedReleaseDate: '',
                availabilityType: '',
                description: '',
                sample: {}, // Sample
                publisher: {}, // Publisher
                type: { id: 'ebook' }, // Type
                covers: {}, // Covers

                // Custom Lightning Properties
                titleState: 'waiting',
                isRecommended: false,
                wishlistState: 'wishlistAdd',
                isInHistory: false,
                addToAppFormat: null,
                isOnHold: false,
                isReleasedHold: false,
                isBorrowed: false
            };
        }
    }, {
        key: 'setContext',
        value: function setContext(context) {
            this.context = context;
        }
    }, {
        key: 'idAttribute',
        get: function get() {
            return 'id';
        }
    }, {
        key: 'isPlaceholder',
        get: function get() {
            return this.get('placeholder');
        }
    }]);

    function Title(model, options, context) {
        _classCallCheck(this, Title);

        var _ref = options || {},
            patronItems = _ref.patronItems;

        var _this = _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).call(this, model, options));

        _this.setContext(context);

        _this.set(_.extend({}, model, { titleState: _this._getState(patronItems) }));
        if (!_this.isPlaceholder) {
            _this.link(window.globalEvents);
        }
        return _this;
    }

    _createClass(Title, [{
        key: 'link',
        value: function link(bus) {
            var _this2 = this;

            // Unlink the old bus if there is one
            if (this.bus) {
                this.stopListening(this.bus, 'title:update');
                this.bus = null;
            }

            // Attach new bus if passed
            if (bus) {
                this.bus = bus;
                this.listenTo(this.bus, 'title:update', function (titleModel) {
                    _this2._applyUpdates(titleModel);
                });
            }

            return this;
        }
    }, {
        key: '_applyUpdates',
        value: function _applyUpdates(titleModel) {
            if (titleModel !== this && titleModel.id === this.id) {
                _get(Title.prototype.__proto__ || Object.getPrototypeOf(Title.prototype), 'set', this).call(this, titleModel.changedAttributes());
            }
        }
    }, {
        key: 'set',
        value: function set() {
            _get(Title.prototype.__proto__ || Object.getPrototypeOf(Title.prototype), 'set', this).apply(this, arguments);
            this.bus && this.bus.trigger('title:update', this);
        }

        // An example of this can be seen in CollectionHightlight.js:61 (where TitleCollectionView gets new'ed up)

    }, {
        key: 'updatePatronState',
        value: function updatePatronState(patronItems) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.set({
                titleState: this._getState(patronItems),
                wishlistState: _TitleState2['default'].isOnWishlist(this.attributes, patronItems) ? 'wishlistRemove' : 'wishlistAdd',
                userStarRating: _TitleState2['default'].starRating(this.attributes, patronItems) // 0 if not rated
            }, options);
            var readingHistoryState = _TitleState2['default'].isOnReadingHistory(this.attributes, patronItems);
            this.set('isInHistory', readingHistoryState, options || {});

            var userStarRating = _TitleState2['default'].starRating(this.attributes, patronItems);
            this.set('userStarRating', userStarRating, options || {}); // 0 if not rated
        }
    }, {
        key: 'getCover',
        value: function getCover(desiredSize) {
            var covers = _.map(this.get('covers'), function (cover) {
                return cover;
            }); // maps to collection of covers
            var coversBySize = _.sortBy(covers, 'width'); // coversBySize is now an array of covers, from smallest to largest


            // Start with the biggest cover
            // Copy object with Object.assign() so we dont damage reference
            var optimizedCover = Object.assign({}, _.last(covers));

            // if this image opto stuff catches on we'll figure out a way
            // to get cleaner image urls, which will make this all much
            // simpler
            if (optimizedCover && optimizedCover.href) {
                var legacyImageHost = 'https://img1.od-cdn.com/';
                var optimizedImageHost = 'https://ic.od-cdn.com/';
                var optimizedUrl = optimizedCover.href.replace(legacyImageHost, optimizedImageHost);

                // format=auto -> use webp if the device supports it
                var optimizations = 'quality=80&w=' + desiredSize;
                var queryString = (optimizedUrl.indexOf('?') < 0 ? '?' : '&') + optimizations;
                optimizedCover.href = optimizedUrl + queryString;

                return optimizedCover;
            }

            var smallestCoverThatIsBigEnough = _.find(coversBySize, function (cover) {
                return cover.width >= desiredSize;
            }) || _.last(covers); // finds the first cover that is big enough
            return smallestCoverThatIsBigEnough;
        }
    }, {
        key: 'getCoverSrc',
        value: function getCoverSrc(desiredSize) {
            var cover = this.getCover(desiredSize);
            return cover && cover.href || '/public/img/no-cover_en_US.jpg';
        }
    }, {
        key: 'getCurrentAvailability',
        value: function getCurrentAvailability() {
            return $.ajax({
                url: window.url(window.routes.mediaAvailabilityId, { id: this.id }),
                type: 'GET',
                timeout: 0
            });
        }
    }, {
        key: 'getMissingAttribute',
        value: function getMissingAttribute(attribute) {
            var _this3 = this;

            if (!this._mediaInterface) {
                this._mediaInterface = new _MediaInterface2['default']();
            }
            return this._mediaInterface.search({ titleId: this.get('id') }).then(function (response) {
                _this3.set(attribute, response[attribute]);
                return Promise.resolve();
            });
        }
    }, {
        key: 'availabilityText',
        value: function availabilityText() {
            var action = this.get('titleState');
            var availabilityText = '';

            switch (action) {
                case 'recommend':
                    availabilityText = window.html('availabilityNotOwned');
                    break;
                case 'recommended':
                    availabilityText = window.html('recommended');
                    break;
                case 'unavailable':
                    availabilityText = window.html('availabilityUnavailable');
                    break;
                case 'nook':
                    availabilityText = window.html('availabilityAvailable');
                    break;
                case 'borrow' || 'preview':
                    availabilityText = window.html('availabilityAvailable');
                    break;
                case 'borrowed':
                case 'addToApp':
                case 'listenNow':
                case 'readNow':
                    availabilityText = window.html('borrowed');
                    break;
                case 'hold':
                    if (this.get('isPreReleaseTitle')) {
                        availabilityText = window.html('availabilityComingSoon');
                        break;
                    }

                    availabilityText = this.get('isPreReleaseTitle') ? window.html('availabilityComingSoon') : window.html('availabilityWaitList');
                    break;
                case 'onHold':
                    availabilityText = window.html('onHold');
                    break;
                case 'waiting':
                    availabilityText = window.html('loading');
                    break;
            }

            return availabilityText;
        }
    }, {
        key: '_getState',
        value: function _getState(patronItems) {
            this.setPatronState(patronItems);
            return _TitleState2['default'].getState(this.attributes, patronItems);
        }
    }, {
        key: 'setPatronState',
        value: function setPatronState(patronItems) {
            this.set({ isOnHold: patronItems && patronItems.onHolds.indexOf(this.id) > -1 });
            this.set({ isBorrowed: patronItems && patronItems.onCheckouts.indexOf(this.id) > -1 });
            this.set({ isRecommended: patronItems && patronItems.recommendedToLibrary.indexOf(this.id) > -1 });
        }
    }, {
        key: 'sanitizedDesc',
        value: function sanitizedDesc() {
            var desc = this.get('description').replace(/(<br\s*[\/]?>)|(\r?\n|\r)/gim, ' ');
            return $('<div>' + desc + '</div>').text();
        }
    }, {
        key: 'getTitleAsync',
        value: function getTitleAsync(mediaId, resolve, reject) {
            var _this4 = this;

            $.ajax({
                url: window.url(window.routes.mediaInfoId, { id: mediaId }),
                type: 'GET',
                timeout: 10000,
                success: function success(data) {
                    _this4.set(data);
                    _this4.set('titleState', _this4._getState(null));
                    resolve();
                },
                fail: function fail(err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'contextCollectionId',
        get: function get() {
            return this.context && this.context.collectionDefinition ? this.context.collectionDefinition.id : undefined;
        }
    }, {
        key: 'titleDetailsUrl',
        get: function get() {
            // LHTNG-3018 Reference optional contextCollectionId value when creating a title details link
            var props = { id: this.id };

            if (this.contextCollectionId) {
                props.cid = this.contextCollectionId;
            }

            return window.url(window.routes.mediaId, props);
        }
    }, {
        key: 'hasLuckyDayCopies',
        get: function get() {
            return window.featureManager.isEnabled('LuckyDay') && this.get('luckyDayOwnedCopies') > 0;
        }
    }, {
        key: 'allCopiesAreLuckyDay',
        get: function get() {
            return this.hasLuckyDayCopies && this.get('ownedCopies') === 0;
        }
    }, {
        key: 'isLuckyDayCheckout',
        get: function get() {
            return this.hasAvailableLuckyDayCopies && this.get('availableCopies') === 0 && !this.get('isReleasedHold');
        }
    }, {
        key: 'canPlaceHold',
        get: function get() {
            return this.get('isHoldable') && !this.get('isOnHold') && window.featureManager.isEnabled('content-holds');
        }
    }, {
        key: 'isAvailable',
        get: function get() {
            return this.get('isAvailable') || this.hasAvailableLuckyDayCopies;
        }
    }, {
        key: 'hasAvailableLuckyDayCopies',
        get: function get() {
            return this.hasLuckyDayCopies && this.get('luckyDayAvailableCopies') > 0;
        }
    }, {
        key: 'isMagazine',
        get: function get() {
            return this.get('type').id === 'magazine';
        }
    }]);

    return Title;
}(Backbone.Model);

exports['default'] = Title;

},{"../../../title-actions/TitleState":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleState.js","../MediaInterface":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Title = require('./Title');

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleCollection = function (_Backbone$Collection) {
    _inherits(TitleCollection, _Backbone$Collection);

    function TitleCollection() {
        _classCallCheck(this, TitleCollection);

        return _possibleConstructorReturn(this, (TitleCollection.__proto__ || Object.getPrototypeOf(TitleCollection)).apply(this, arguments));
    }

    _createClass(TitleCollection, [{
        key: 'model',
        get: function get() {
            return _Title2['default'];
        }
    }]);

    return TitleCollection;
}(Backbone.Collection);

exports['default'] = TitleCollection;

},{"./Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\ContextMenu.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

exports['default'] = function (_ref) {
    var id = _ref.id,
        rid = _ref.rid,
        typeId = _ref.typeId,
        title = _ref.title,
        alignment = _ref.alignment,
        sampleHref = _ref.sampleHref,
        sampleText = _ref.sampleText,
        historyActionLabel = _ref.historyActionLabel,
        historyActionText = _ref.historyActionText,
        historyEnabled = _ref.historyEnabled,
        gaHistoryAction = _ref.gaHistoryAction,
        seriesSearchUrl = _ref.seriesSearchUrl;
    return '\n<div class="ContextMenu">\n    <div tabindex="0" class="ContextMenu-button js-context-button" data-media-id="' + id + '"\n         data-title="' + title + '"\n         data-dropdown="context-menu-' + id + '-' + rid + '"\n         data-options="align:' + alignment + '"\n         aria-controls="more-actions-drop-' + id + '"\n         aria-expanded="false"\n         aria-label="' + html('cover.titleInfo', { title: title }) + '"\n         role="button">\n        <i class="icon icon-more" tabindex="-1"></i>\n    </div>\n\n    <ul id="context-menu-' + id + '-' + rid + '" class="ContextMenu-drop js-context-drop f-dropdown text-left" data-dropdown-content aria-hidden="false" tabindex="-1" role="list" aria-haspopup="true">\n        ' + (sampleHref !== '' ? '\n            <li class="read-sample ContextMenu-item">\n                <a data-href="' + sampleHref + '" data-media-id="' + id + '" data-title="' + title + '"\n                   data-of-dropdown="more-actions-drop-' + id + '" data-type="' + typeId + '"\n                   tabindex="-1" href="javascript:void(0)" aria-label="' + html('cover.sampleLabel', { sample: sampleText, title: title }) + '">\n                    ' + sampleText + '\n                </a>\n            </li>' : '') + '\n        <li class="ContextMenu-item">\n            <a tabindex="-1" href="' + url(routes.mediaId, { id: id }) + '" aria-label="' + html('viewDetailsAboutTitle', { title: title }) + '">' + html('viewDetails') + '</a>\n        </li>\n        ' + (seriesSearchUrl ? '\n            <li class="ContextMenu-item"><a tabindex="-1" href="' + seriesSearchUrl + '">' + html('viewSeries') + '</a></li>' : '') + '\n        ' + (historyEnabled ? '<li class="ContextMenu-item js-historyAction" data-ga-action="' + gaHistoryAction + '" data-media-id="' + id + '"><a tabindex="-1" role="button" aria-label="' + historyActionLabel + '">' + historyActionText + '</a></li>' : '') + '\n        <li class="ContextMenu-item"><a tabindex="-1" href="' + url(routes.mediaRelatedId, { id: id }) + '" aria-label="' + html('viewRelatedToTitle', { title: title }) + '">' + html('youMayAlsoLike') + '</a></li>\n    </ul>\n</div>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\CopiesAvailable.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var withIcons = _ref.withIcons,
        availabilityText = _ref.availabilityText,
        waitingText = _ref.waitingText,
        helpButtonHTML = _ref.helpButtonHTML;
    return '\n<div class=\'CopiesAvailable\'>\n    ' + (availabilityText ? '\n        <div class=\'availability\'>\n            <span class=\'availabilityText\'>\n                ' + (withIcons ? '<i class="icon-copies"></i>' : '') + '\n                ' + availabilityText + '\n            </span>\n            ' + (!waitingText && helpButtonHTML ? '\n                <span>\n                    ' + helpButtonHTML + '\n                </span>\n            ' : '') + '\n        </div>\n    ' : '') + '\n    ' + (waitingText ? '\n        <div class=\'waiting\'>\n            <span>\n                ' + (withIcons ? '<i class="icon-holds"></i>' : '') + '\n                ' + waitingText + '\n            </span>\n            ' + (helpButtonHTML ? '\n                <span>\n                    ' + helpButtonHTML + '\n                </span>\n            ' : '') + '\n        </div>\n    ' : '') + '\n</div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\Cover.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function (_ref) {
    var media = _ref.media,
        src = _ref.src,
        href = _ref.href,
        coverColor = _ref.coverColor,
        noSampleClass = _ref.noSampleClass;
    return "\n<div class=\"CoverImageContainer\" style=\"background-color: " + coverColor + "\">\n    <a href=\"" + href + "\"\n           tabindex=\"-1\"\n           data-href    =\"" + href + "\"\n           data-media-id=\"" + media.id + "\"\n           data-title   =\"" + media.title + "\"\n           data-type    =\"" + media.type.id + "\">\n        <img\n            tabindex=\"-1\"\n            aria-label=\"" + media.title + " - " + html(media.type.id) + "\"\n            tabindex=\"0\"\n            class=\"large-title js-details-cover-image " + noSampleClass + "\"\n            src=\"" + src + "\"\n            srcset=\"" + src + "&dpr=2 2x,\n                    " + src + "&dpr=1.5 1.5x,\n                    " + src + " 1x\"\n            alt=\"" + media.title + " - " + html(media.type.id) + "\"\n            style=\"background-color: " + coverColor + "; max-height: none !important;\"/>\n    </a>\n</div>";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\NoCover.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var media = _ref.media,
        href = _ref.href,
        isInHero = _ref.isInHero,
        coverWidth = _ref.coverWidth,
        coverHeight = _ref.coverHeight,
        creatorText = _ref.creatorText;
    return '\n<div class="CoverImageContainer">\n<a class="CoverImageContainer noCoverAvailable ' + (isInHero ? 'secondary-background' : 'primary-background') + '"\n    href="' + href + '"\n    tabindex="-1"\n    data-href    ="' + href + '"\n    data-media-id="' + media.id + '"\n    data-title   ="' + media.title + '"\n    data-type    ="' + media.type.id + '">\n        <div class="title ' + (isInHero ? 'secondary-font-highlight-box' : 'primary-font primary-font-highlight-box') + '">' + media.title + '</div>\n        <div class="author ' + (isInHero ? '' : 'primary-font') + '">' + creatorText + '</div>\n\n        <img\n            tabindex="-1"\n            aria-label="' + media.title + ' - ' + html(media.type.id) + '"\n            tabindex="0"\n            class="large-title js-details-cover-image"\n            src="' + (window.OverDrive.cdn + '/public/img/clear.gif') + '"\n            alt="' + media.title + ' - ' + html(media.type.id) + '"\n            />\n\n</a>\n</div>\n\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\StarViewTemplate.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var index = _ref.index,
        isFilled = _ref.isFilled,
        isHalfFilled = _ref.isHalfFilled,
        label = _ref.label,
        rid = _ref.rid;
    return '\n    <input id=\'star' + index + '-' + rid + '\' class=\'starRadio\' type=\'radio\' value=\'' + index + '\' aria-label=\'' + label + '\' name=\'' + rid + '\'/>\n    <span for=\'star' + index + '-' + rid + '\'><i data-index=\'' + index + '\' class=\'icon icon-star contrast StarRatings-star ' + (isHalfFilled ? 'halfFilled' : '') + ' ' + (!!isFilled ? 'filled' : '') + '\'></i></span>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleCard.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function () {
    return "\n<div class=\"title-contents card TitleCard\">\n    <div class=\"TitleHeaderBar\"></div>\n\n    <div class=\"CoverImage\"></div>\n\n    <div class=\"InfoPanel\">\n        <div class=\"TitleInfo\"></div>\n\n        <div class=\"TitleAction is-grid\"></div>\n\n        <div class=\"TitleWishlist is-grid\"></div>\n    </div>\n\n    <div class=\"clear\" />\n</div>";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleFormatBadge.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var typeId = _ref.typeId;
    return '\n' + (typeId ? '\n    <span class="title-format-badge contrast u-allCaps"><i class="icon-' + typeId + '"></i>' + window.html(typeId) + '</span>\n' : '') + '\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleName.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function (_ref) {
    var titleId = _ref.titleId,
        title = _ref.title,
        href = _ref.href,
        ariaLabel = _ref.ariaLabel;
    return "<h3 title=\"" + title + "\" class=\"title-name\" data-media-id=\"" + titleId + "\" tabindex=\"-1\">\n    <a tabindex=\"0\" href=\"" + href + "\" role=\"link\" aria-label=\"" + ariaLabel + "\">\n        " + title + "\n    </a>\n</h3>";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitlePreRelease.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (_ref) {
  var date = _ref.date;
  return '<p class=\'title-prerelease\'> ' + window.html('accountHolds.prereleaseExpected', { date: date }) + '</p>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\WishListButton.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var ga = _ref.ga,
        contrastClass = _ref.contrastClass,
        ariaLabel = _ref.ariaLabel,
        iconClass = _ref.iconClass,
        text = _ref.text;
    return '\n<button ' + (ga ? 'data-ga-track="wishlist" data-ga-mediaID="' + ga.mediaId + '" data-ga-type=' + ga.formatType : '') + '\nclass="WishListButton ' + contrastClass + '" \ntype="button" \naria-label="' + ariaLabel + '">\n    <i class="' + iconClass + ' icon animated bounceIn" aria-hidden="true"></i>\n    ' + (text ? '<span class="u-allCaps WishListButton-text">' + text + '</span>' : '') + '\n</button>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleCollectionViewSelector.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MediaViewPreference = require('../models/MediaViewPreference');

var _MediaViewPreference2 = _interopRequireDefault(_MediaViewPreference);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewSelectorButton = function (_Backbone$View) {
    _inherits(ViewSelectorButton, _Backbone$View);

    function ViewSelectorButton() {
        _classCallCheck(this, ViewSelectorButton);

        var _this = _possibleConstructorReturn(this, (ViewSelectorButton.__proto__ || Object.getPrototypeOf(ViewSelectorButton)).apply(this, arguments));

        _this.isSelectEvent = function (e) {
            return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        };

        if (_this.constructor === ViewSelectorButton) {
            throw new TypeError('ViewSelectorButton cannot be instantiated directly');
        }

        _this.listenTo(_this.model, 'change', _this.render);

        _this.$el.on('click keypress', function (e) {
            if (_this.isSelectEvent(e)) {
                _this.select();
                return false;
            }
            return true;
        });
        return _this;
    }

    _createClass(ViewSelectorButton, [{
        key: 'select',
        value: function select() {
            this.model.set({ view: this.view });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.view || !this.template) {
                throw new Error('this.view and this.template are required');
            }

            this.$el.html(this.template({
                selected: this.model.get('view') === this.view
            }));
        }
    }]);

    return ViewSelectorButton;
}(Backbone.View);

var GridViewSelectorButton = function (_ViewSelectorButton) {
    _inherits(GridViewSelectorButton, _ViewSelectorButton);

    function GridViewSelectorButton() {
        _classCallCheck(this, GridViewSelectorButton);

        var _this2 = _possibleConstructorReturn(this, (GridViewSelectorButton.__proto__ || Object.getPrototypeOf(GridViewSelectorButton)).apply(this, arguments));

        _this2.template = function (_ref) {
            var selected = _ref.selected;
            return '<a tabindex="0" class="view-as-grid" aria-label="' + html('results.viewInGrid') + '" role="button" style="display: inline;">\n                    <i class="icon-grid ' + (!selected && 'gray') + '" aria-hidden="true"></i>\n                </a>';
        };
        _this2.view = _MediaViewPreference2['default'].options.grid;
        return _this2;
    }

    return GridViewSelectorButton;
}(ViewSelectorButton);

var ListViewSelectorButton = function (_ViewSelectorButton2) {
    _inherits(ListViewSelectorButton, _ViewSelectorButton2);

    function ListViewSelectorButton() {
        _classCallCheck(this, ListViewSelectorButton);

        var _this3 = _possibleConstructorReturn(this, (ListViewSelectorButton.__proto__ || Object.getPrototypeOf(ListViewSelectorButton)).apply(this, arguments));

        _this3.template = function (_ref2) {
            var selected = _ref2.selected;
            return '<a tabindex="0" class="view-as-list" aria-label="' + html('results.viewInList') + '" role="button" style="display: inline;">\n                        <i class="icon-list ' + (!selected && 'gray') + '" aria-hidden="true"></i>\n                    </a>';
        };
        _this3.view = _MediaViewPreference2['default'].options.list;
        return _this3;
    }

    return ListViewSelectorButton;
}(ViewSelectorButton);

var TitleCollectionViewSelector = function (_Backbone$View2) {
    _inherits(TitleCollectionViewSelector, _Backbone$View2);

    function TitleCollectionViewSelector(options) {
        _classCallCheck(this, TitleCollectionViewSelector);

        var _this4 = _possibleConstructorReturn(this, (TitleCollectionViewSelector.__proto__ || Object.getPrototypeOf(TitleCollectionViewSelector)).call(this, options));

        _this4.template = function () {
            return '\n        <div style="position: relative">\n            <div class="GridViewButton"></div>\n            <div class="ListViewButton"></div>\n        </div>';
        };

        _this4.model = new _MediaViewPreference2['default']();

        _this4.$el.prepend(_this4.template());

        _this4.listViewButton = new ListViewSelectorButton({
            el: _this4.$('.ListViewButton'),
            model: _this4.model
        }).render();
        _this4.gridViewButton = new GridViewSelectorButton({ el: _this4.$('.GridViewButton'),
            model: _this4.model
        }).render();

        return _this4;
    }

    return TitleCollectionViewSelector;
}(Backbone.View);

exports['default'] = TitleCollectionViewSelector;

},{"../models/MediaViewPreference":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\MediaViewPreference.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleDescription.js":[function(require,module,exports){
'use strict';

var Backbone = window.Backbone;

var TitleDescription = Backbone.View.extend({
    initialize: function initialize() {
        this.render();
    },
    template: function template() {
        return '\n            ' + this._description() + '\n            ' + this._readMoreLink() + '\n        ';
    },
    _readMoreLink: function _readMoreLink() {
        if (this.model.get('description').length) {
            return '\n                <a href="' + this.model.titleDetailsUrl + '" class="expand-description contrast secondary-hover-underline">\n                        ' + window.html('cover.readMore') + '\n                </a>\n            ';
        }

        return '';
    },
    _description: function _description() {
        if (this.model.get('description').length) {
            return this.model.sanitizedDesc();
        }

        return window.html('titleDetails.noDescAvailable');
    },
    render: function render() {
        this.$el.html(this.template());
    }
});

module.exports = TitleDescription;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContextMenu = require('../ContextMenu');

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

var _TitleAuthor = require('./TitleInfo/TitleAuthor');

var _TitleAuthor2 = _interopRequireDefault(_TitleAuthor);

var _TitleEdition = require('./TitleInfo/TitleEdition');

var _TitleEdition2 = _interopRequireDefault(_TitleEdition);

var _TitleName = require('./TitleInfo/TitleName');

var _TitleName2 = _interopRequireDefault(_TitleName);

var _TitleFormatBadge = require('./TitleInfo/TitleFormatBadge');

var _TitleFormatBadge2 = _interopRequireDefault(_TitleFormatBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleInfo = function (_Backbone$View) {
    _inherits(TitleInfo, _Backbone$View);

    _createClass(TitleInfo, [{
        key: 'className',
        get: function get() {
            return 'title-info';
        }
    }]);

    function TitleInfo() {
        _classCallCheck(this, TitleInfo);

        var _this = _possibleConstructorReturn(this, (TitleInfo.__proto__ || Object.getPrototypeOf(TitleInfo)).apply(this, arguments));

        _this._views = [];

        _this.render();
        return _this;
    }

    _createClass(TitleInfo, [{
        key: '_reset',
        value: function _reset() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._reset();
            _get(TitleInfo.prototype.__proto__ || Object.getPrototypeOf(TitleInfo.prototype), 'remove', this).call(this);
        }
    }, {
        key: 'render',
        value: function render() {
            this._reset();

            this._views.push(this.contextMenu = new _ContextMenu2['default']({ model: this.model }));
            if (this.model.isMagazine) {
                this._views.push(this.titleEdition = new _TitleEdition2['default']({ model: this.model }));
            } else {
                this._views.push(this.titleAuthor = new _TitleAuthor2['default']({ model: this.model }));
            }

            this._views.push(this.titleName = new _TitleName2['default']({ model: this.model }));
            this._views.push(this.titleFormatBadge = new _TitleFormatBadge2['default']({ typeId: this.model.get('type').id }));

            this.$el.empty();
            this.$el.append(this.titleName.$el, this.contextMenu.$el.addClass('text-right'), this.model.isMagazine ? this.titleEdition.$el : this.titleAuthor.$el, this.titleFormatBadge.$el);
        }
    }]);

    return TitleInfo;
}(Backbone.View);

exports['default'] = TitleInfo;

},{"../ContextMenu":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\ContextMenu.js","./TitleInfo/TitleAuthor":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleAuthor.js","./TitleInfo/TitleEdition":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleEdition.js","./TitleInfo/TitleFormatBadge":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleFormatBadge.js","./TitleInfo/TitleName":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleName.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfoListView.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContextMenu = require('../ContextMenu');

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

var _TitleAuthor = require('./TitleInfo/TitleAuthor');

var _TitleAuthor2 = _interopRequireDefault(_TitleAuthor);

var _TitleEdition = require('./TitleInfo/TitleEdition');

var _TitleEdition2 = _interopRequireDefault(_TitleEdition);

var _TitleName = require('./TitleInfo/TitleName');

var _TitleName2 = _interopRequireDefault(_TitleName);

var _TitleFormatBadge = require('./TitleInfo/TitleFormatBadge');

var _TitleFormatBadge2 = _interopRequireDefault(_TitleFormatBadge);

var _TitleSeries = require('./TitleInfo/TitleSeries');

var _TitleSeries2 = _interopRequireDefault(_TitleSeries);

var _TitlePreRelease = require('./TitleInfo/TitlePreRelease');

var _TitlePreRelease2 = _interopRequireDefault(_TitlePreRelease);

var _StarRating = require('./TitleInfo/StarRating');

var _StarRating2 = _interopRequireDefault(_StarRating);

var _CopiesAvailable = require('./TitleInfo/CopiesAvailable');

var _CopiesAvailable2 = _interopRequireDefault(_CopiesAvailable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleInfoListView = function (_Backbone$View) {
    _inherits(TitleInfoListView, _Backbone$View);

    _createClass(TitleInfoListView, [{
        key: 'className',
        get: function get() {
            return 'title-info';
        }
    }]);

    function TitleInfoListView() {
        _classCallCheck(this, TitleInfoListView);

        var _this = _possibleConstructorReturn(this, (TitleInfoListView.__proto__ || Object.getPrototypeOf(TitleInfoListView)).apply(this, arguments));

        _this._views = [];

        _this.render();
        return _this;
    }

    _createClass(TitleInfoListView, [{
        key: '_reset',
        value: function _reset() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._reset();
            _get(TitleInfoListView.prototype.__proto__ || Object.getPrototypeOf(TitleInfoListView.prototype), 'remove', this).call(this);
        }
    }, {
        key: 'render',
        value: function render() {
            this._reset();

            this._views.push(this.contextMenu = new _ContextMenu2['default']({ model: this.model }));

            if (this.model.isMagazine) {
                this._views.push(this.titleEdition = new _TitleEdition2['default']({ model: this.model }));
            } else {
                this._views.push(this.titleAuthor = new _TitleAuthor2['default']({ model: this.model }));
            }
            this._views.push(this.titleName = new _TitleName2['default']({ model: this.model }));
            this._views.push(this.titleSeries = new _TitleSeries2['default']({ model: this.model }));
            this._views.push(this.titleFormatBade = new _TitleFormatBadge2['default']({ typeId: this.model.get('type').id }));
            this._views.push(this.titlePreRelease = new _TitlePreRelease2['default']({ model: this.model }));
            this._views.push(this.copiesAvailable = new _CopiesAvailable2['default']({ model: this.model }));
            this._views.push(this.starRating = new _StarRating2['default']({ model: this.model, el: $('<div />', { 'class': 'star-rating list-view' }), type: 'editable' }).render());

            this.$el.empty();
            this.$el.append(this.titleName.$el, this.contextMenu.$el.addClass('text-right'), this.titleSeries.$el, this.model.isMagazine ? this.titleEdition.$el : this.titleAuthor.$el, this.titleFormatBade.$el);

            if (!!this.model.get('isPreReleaseTitle')) {
                this.$el.append(this.titlePreRelease.$el);
            } else {
                this.$el.append(this.starRating.$el);
            }

            this.$el.append(this.copiesAvailable.$el);
        }
    }]);

    return TitleInfoListView;
}(Backbone.View);

exports['default'] = TitleInfoListView;

},{"../ContextMenu":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\ContextMenu.js","./TitleInfo/CopiesAvailable":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\CopiesAvailable.js","./TitleInfo/StarRating":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\StarRating.js","./TitleInfo/TitleAuthor":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleAuthor.js","./TitleInfo/TitleEdition":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleEdition.js","./TitleInfo/TitleFormatBadge":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleFormatBadge.js","./TitleInfo/TitleName":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleName.js","./TitleInfo/TitlePreRelease":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitlePreRelease.js","./TitleInfo/TitleSeries":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleSeries.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\CopiesAvailable.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldInformationModal = require('../../../holdInformation/views/HoldInformationModal');

var _HoldInformationModal2 = _interopRequireDefault(_HoldInformationModal);

var _HoldInformationModalV = require('../../../holdInformationV2/HoldInformationModalV2');

var _HoldInformationModalV2 = _interopRequireDefault(_HoldInformationModalV);

var _HoldInformationV = require('../../../holdInformationV2/HoldInformationV2');

var _HoldInformationV2 = _interopRequireDefault(_HoldInformationV);

var _CopiesAvailable = require('../../templates/CopiesAvailable.html');

var _CopiesAvailable2 = _interopRequireDefault(_CopiesAvailable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopiesAvailable = function (_Backbone$View) {
    _inherits(CopiesAvailable, _Backbone$View);

    function CopiesAvailable(_ref) {
        var withIcons = _ref.withIcons;

        _classCallCheck(this, CopiesAvailable);

        var _this = _possibleConstructorReturn(this, (CopiesAvailable.__proto__ || Object.getPrototypeOf(CopiesAvailable)).apply(this, arguments));

        _this.title = _this.model.toJSON();
        _this.withIcons = withIcons;
        _this.listenTo(_this.model, 'change:titleState', _this._maybeRender);
        _this.render();
        return _this;
    }

    _createClass(CopiesAvailable, [{
        key: 'events',
        value: function events() {
            return {
                'click .js-holds-ratio-help-icon': '_renderModal'
            };
        }
    }, {
        key: 'render',
        value: function render() {
            this.$el.empty();
            if (this.model.allCopiesAreLuckyDay) {
                return this;
            }

            if (this.title.titleState === 'unavailable') {
                this._renderNormal();
                return this;
            } else if (this.title.isPreReleaseTitle) {
                this._renderNormal();
                return this;
            }

            switch (this.title.availabilityType) {
                case 'normal':
                    this._renderNormal();
                    break;
                case 'always':
                    this.$el.append((0, _CopiesAvailable2['default'])({
                        withIcons: this.withIcons,
                        availabilityText: window.text('cover.alwaysAvailable')
                    }));
                    break;
                case 'limited' && !this.title.isAvailable:
                    this.$el.append((0, _CopiesAvailable2['default'])({
                        withIcons: this.withIcons,
                        availabilityText: window.text('cover.limitedAvailability')
                    }));
                    break;
            }

            return this;
        }
    }, {
        key: '_maybeRender',
        value: function _maybeRender() {
            if ((window.featureManager.isEnabled('betterPatronState') ? this.model.get('isOnHold') : this.model.get('titleState') === 'onHold') || (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isBorrowed') : this.model.get('titleState') === 'borrowed')) {
                this.render();
            }

            if (this.model.allCopiesAreLuckyDay) {
                this.render();
            }
        }
    }, {
        key: '_renderNormal',
        value: function _renderNormal() {
            var availabilityText = void 0,
                waitingText = void 0,
                helpButtonHTML = void 0;

            var notHeldClass = (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isOnHold') : this.model.get('titleState') === 'onHold') ? '' : 'js-holds-ratio-not-held';

            if (this.title.type.id === 'periodicals' && this.title.availableCopies < 1 && !this.title.isAvailable) {
                availabilityText = window.html('cover.limitedAvailability');
                helpButtonHTML = '\n                <button\n                aria-label="' + window.html('cover.whyLimitedAvailability') + '"\n                data-reveal-id="limited-periodical-availability"\n                class="help-tip secondary-background">\n                </button>\n                ';
            } else {

                var copyVariables = {
                    availableCopies: window.featureManager.isEnabled('LuckyDay') ? this.title.availableCopies + this.title.luckyDayAvailableCopies : this.title.availableCopies,
                    ownedCopies: window.featureManager.isEnabled('LuckyDay') ? this.title.ownedCopies + this.title.luckyDayOwnedCopies : this.title.ownedCopies
                };
                availabilityText = window.html('cover.copiesAvailable', copyVariables);

                if (this.model.allCopiesAreLuckyDay && this.title.titleState === 'unavailable') {
                    availabilityText = window.html('cover.copiesAvailable', { availableCopies: 0, ownedCopies: this.title.luckyDayOwnedCopies });
                }

                if (!this.title.isAvailable && !this.model.hasAvailableLuckyDayCopies) {
                    if (!this.model.allCopiesAreLuckyDay) {
                        if (window.featureManager.isEnabled('LHTNG-2863')) {
                            if (this.title.isOwned) {
                                waitingText = new _HoldInformationV2['default']({ model: this.model, isVisitor: window.OverDrive.isVisitor }).waitTimeHtml;
                            }
                        } else if (!this.model.get('isFastlane')) {
                            if (this.title.holdsRatio) {
                                waitingText = window.html('cover.waitingPerCopy', { holdsRatio: this.title.holdsRatio });
                            } else if (this.title.holdsCount === 0) {
                                waitingText = window.html('cover.noHolds');
                            }
                        }
                    }
                    helpButtonHTML = window.featureManager.isEnabled('LHTNG-2863') && !this.title.isOwned ? '' : ' <button\n                    data-media-id="' + this.title.id + '"\n                    aria-label="' + window.html('cover.holdsRatioExplanation') + '"\n                    class="help-tip secondary-background js-holds-ratio-help-icon ' + notHeldClass + '">\n                    </button>\n                    ';
                }
            }

            this.$el.append((0, _CopiesAvailable2['default'])({
                withIcons: this.withIcons,
                availabilityText: availabilityText,
                waitingText: waitingText,
                helpButtonHTML: helpButtonHTML
            }));
        }
    }, {
        key: '_renderModal',
        value: function _renderModal() {
            var _this2 = this;

            if (window.featureManager.isEnabled('LHTNG-2863')) {
                if (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isOnHold') : this.model.get('titleState') === 'onHold') {
                    window.ajax.getHold(this.model.get('id')).done(function (holdData) {
                        // should be confirming that this is on hold
                        _this2.model.set({
                            holdsRatio: holdData.holdsRatio,
                            holdsCount: holdData.holdsCount,
                            holdListPosition: holdData.holdListPosition
                        });
                        _this2.modal = new _HoldInformationModalV2['default']({ model: _this2.model, el: _this2.el });
                    });
                } else {
                    this.modal = new _HoldInformationModalV2['default']({ model: this.model, el: this.el, hideHoldsLink: true });
                }
            } else {
                var isFastlane = this.model.get('isFastlane');
                var titleState = this.model.get('titleState');
                if (!!isFastlane) {
                    this.modal = new _HoldInformationModal2['default']({ model: this.model, type: 'basic', el: this.el });
                } else if (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isOnHold') : this.model.get('titleState') === 'onHold') {
                    window.ajax.getHold(this.model.get('id')).done(function (holdData) {
                        // should be confirming that this is on hold
                        _this2.model.set({
                            holdsRatio: holdData.holdsRatio,
                            holdsCount: holdData.holdsCount,
                            holdListPosition: holdData.holdListPosition
                        });
                        _this2.modal = new _HoldInformationModal2['default']({ model: _this2.model, type: 'successPosition', el: _this2.el });
                    });
                } else {
                    this.modal = new _HoldInformationModal2['default']({ model: this.model, type: 'ratio', el: this.el });
                }
            }
        }
    }]);

    return CopiesAvailable;
}(Backbone.View);

exports['default'] = CopiesAvailable;

},{"../../../holdInformation/views/HoldInformationModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformationModal.js","../../../holdInformationV2/HoldInformationModalV2":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationModalV2.js","../../../holdInformationV2/HoldInformationV2":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.js","../../templates/CopiesAvailable.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\CopiesAvailable.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\StarRating.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _StarView = require('./StarView');

var _StarView2 = _interopRequireDefault(_StarView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    featureManager = _window.featureManager;

var StarRating = function (_Backbone$View) {
    _inherits(StarRating, _Backbone$View);

    _createClass(StarRating, [{
        key: 'events',
        value: function events() {
            return {
                'mouseleave': 'stopHoverRating'
            };
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            _get(StarRating.prototype.__proto__ || Object.getPrototypeOf(StarRating.prototype), 'remove', this).call(this);
        }
    }, {
        key: 'isEnabled',
        get: function get() {
            return !this.model.get('isPreReleaseTitle');
        }
    }]);

    function StarRating() {
        _classCallCheck(this, StarRating);

        var _this = _possibleConstructorReturn(this, (StarRating.__proto__ || Object.getPrototypeOf(StarRating)).apply(this, arguments));

        _this._views = [];
        _this.hoverRating = 0;
        _this.$el.addClass('star-ratings-container StarRatings');

        _this.rid = Math.random().toString(36).substring(7);

        // Update star rating when patron status is received
        _this.listenTo(_this.model, 'change:userStarRating', function (model) {
            _this.update();
        });
        return _this;
    }

    _createClass(StarRating, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.isEnabled) {
                return this;
            }

            var globalRating = this.model.get('starRating') || 0;
            this.$el.attr('data-global-rating', this.model.get('starRating'));
            this.$el.attr('data-media-id', this.model.id);

            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views.length = 0;

            var ctx = this;
            _.each([1, 2, 3, 4, 5, 0], function (index) {
                var viewData = {
                    index: index,
                    globalRating: globalRating,
                    rid: _this2.rid
                };
                var starView = new _StarView2['default'](viewData);

                if (!featureManager.isEnabled('internationalDemoMode')) {
                    starView.on('rate', function (starValue) {
                        ctx.handleRating(starValue);
                    });
                    starView.on('hover', function (starValue) {
                        ctx.onHoverRating(starValue);
                    });
                }

                _this2._views.push(starView);
            });

            this.$el.empty();
            this._views.forEach(function (view) {
                view.render();
                _this2.$el.append(view.$el);
            });
            this.update();

            return this;
        }
    }, {
        key: 'isHalfStar',
        value: function isHalfStar(globalRating) {
            return globalRating % 1 >= 0.25 && globalRating % 1 < 0.75;
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            if (!this.isEnabled) {
                return this;
            }

            var isUserRating = (this.model.get('userStarRating') > 0 || this.hoverRating) > 0;
            this.$el.toggleClass('user-rating', isUserRating);
            var globalRating = this.model.get('starRating') || 0;

            _.each(this._views, function (starView) {

                if (isUserRating) {
                    starView.setFilled(starView.index <= (_this3.hoverRating || _this3.model.get('userStarRating')));
                } else if (starView.index < globalRating) {
                    starView.setFilled(true);
                } else if (starView.index - 1 > globalRating) {
                    starView.setFilled(false);
                } else {
                    starView.setFilled(starView.index - 0.75 < globalRating, _this3.isHalfStar(globalRating));
                }
                starView.$el.children('.starRadio').prop('checked', starView.index === _this3.model.get('userStarRating'));
            });

            return this;
        }
    }, {
        key: 'handleRating',
        value: function handleRating(starValue) {
            var currentRating = this.model.get('userStarRating');
            if (starValue === currentRating) {
                this.model.set('userStarRating', 0);
                this.stopHoverRating();
            } else {
                this.model.set('userStarRating', starValue);
            }
            this.model.trigger('title:action', { action: 'rating', model: this.model });
        }
    }, {
        key: 'onHoverRating',
        value: function onHoverRating(starValue) {
            this.hoverRating = starValue;
            this.update();
        }
    }, {
        key: 'stopHoverRating',
        value: function stopHoverRating() {
            this.hoverRating = 0;
            this.update();
        }
    }]);

    return StarRating;
}(Backbone.View);

exports['default'] = StarRating;

},{"./StarView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\StarView.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\StarView.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StarViewTemplate = require('../../templates/StarViewTemplate.html');

var _StarViewTemplate2 = _interopRequireDefault(_StarViewTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StarView = function (_Backbone$View) {
    _inherits(StarView, _Backbone$View);

    function StarView(_ref) {
        var index = _ref.index,
            _ref$isFilled = _ref.isFilled,
            isFilled = _ref$isFilled === undefined ? false : _ref$isFilled,
            globalRating = _ref.globalRating,
            rid = _ref.rid;

        _classCallCheck(this, StarView);

        var _this = _possibleConstructorReturn(this, (StarView.__proto__ || Object.getPrototypeOf(StarView)).apply(this, arguments));

        _this.template = _StarViewTemplate2['default'];


        _this.index = index;
        _this.isFilled = isFilled;
        _this.isHalfFilled = false;
        _this.label = window.html('starRating.userRatedLabel', { currentRating: _this.index });
        _this.globalRating = globalRating;
        _this.rid = rid;
        _this.$el.addClass('star-container');
        return _this;
    }

    _createClass(StarView, [{
        key: 'events',
        value: function events() {
            return {
                'change': 'onSelected',
                'mouseover .icon-star': 'onHover',
                'click .icon-star': 'onSelected',
                'focusin .noRate': 'pseudoFocus',
                'focusout .noRate': 'pseudoFocus'
            };
        }
    }, {
        key: 'setFilled',
        value: function setFilled(isFilled) {
            var halfFilled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (halfFilled) {
                this.$el.find('.icon-star').removeClass('filled');
                this.isFilled = false;

                this.isHalfFilled = isFilled;
                this.$el.find('.icon-star').toggleClass('halfFilled', isFilled);
            } else {
                this.$el.find('.icon-star').removeClass('halfFilled');
                this.isHalfFilled = false;

                this.isFilled = isFilled;
                this.$el.find('.icon-star').toggleClass('filled', isFilled);
            }
        }
    }, {
        key: 'onSelected',
        value: function onSelected() {
            this.trigger('rate', this.index);
            return false;
        }
    }, {
        key: 'onHover',
        value: function onHover() {
            this.trigger('hover', this.index);
        }

        //Used for the 0th 'no rating' star. When focused, make the container appear to have focus

    }, {
        key: 'pseudoFocus',
        value: function pseudoFocus() {
            this.$el.parent().toggleClass('pseudoFocus');
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.index > 0) {
                this.$el.empty().append(this.template(this));
            } else {
                var noRateTemplate = '<input id=\'noRate-' + this.rid + '\' class=\'starRadio noRate\' type=\'radio\' value=\'0\' name=\'' + this.rid + '\' aria-label=\'' + window.html('starRating.ratedLabel', { rating: this.globalRating }) + '\'/>';
                this.$el.empty().append(noRateTemplate);
            }
        }
    }]);

    return StarView;
}(Backbone.View);

exports['default'] = StarView;

},{"../../templates/StarViewTemplate.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\StarViewTemplate.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleAuthor.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Backbone = window.Backbone;


var path = require('path');
var TitleAuthorTemplate = "<a title=\"<%= text %>\" class=\"secondary-hover-underline\" href=\"<%= href %>\" aria-label=\"<%= label %>\"><%= text %></a>";

var TitleAuthor = Backbone.View.extend({
    template: _.template(TitleAuthorTemplate),

    className: 'title-author',

    tagName: 'p',

    initialize: function initialize() {
        if (this.model.get('type').id !== 'periodicals') {
            this.render();
        }
    },
    render: function render() {
        var title = this.model.toJSON();

        var contents = window.html('cover.noAuthorAvailable');

        if (!_.isEmpty(title.firstCreatorName)) {
            var viewData = {
                href: window.url(window.routes.searchByType, { type: 'creatorId', query: title.firstCreatorId, sortBy: 'newlyadded' }),
                label: window.text('cover.searchByAuthor', { author: _.escape(this.model.get('firstCreatorName')) }),
                text: _.escape(title.firstCreatorName)
            };

            contents = window.text('byLine', { creator: this.template(viewData) });
        }

        this.$el.html(contents);
    }
});

exports['default'] = TitleAuthor;


},{"path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleEdition.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleEdition = function (_Backbone$View) {
    _inherits(TitleEdition, _Backbone$View);

    function TitleEdition() {
        _classCallCheck(this, TitleEdition);

        var _this = _possibleConstructorReturn(this, (TitleEdition.__proto__ || Object.getPrototypeOf(TitleEdition)).apply(this, arguments));

        _this.render();
        return _this;
    }

    _createClass(TitleEdition, [{
        key: 'render',
        value: function render() {
            var node = $('<div class="title-edition">' + this.model.get('edition') + '</div>');
            this.setElement(node);
        }
    }]);

    return TitleEdition;
}(Backbone.View);

exports['default'] = TitleEdition;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleFormatBadge.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleFormatBadge = require('../../templates/TitleFormatBadge.html');

var _TitleFormatBadge2 = _interopRequireDefault(_TitleFormatBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TitleFormatBadge = Backbone.View.extend({
    initialize: function initialize(_ref) {
        var typeId = _ref.typeId;

        this.typeId = typeId;
        this.render();
    },
    render: function render() {
        this.setElement($((0, _TitleFormatBadge2['default'])({ typeId: this.typeId })));
    }
});

exports['default'] = TitleFormatBadge;

},{"../../templates/TitleFormatBadge.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleFormatBadge.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleName.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleName = require('../../templates/TitleName.html');

var _TitleName2 = _interopRequireDefault(_TitleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleName = function (_Backbone$View) {
    _inherits(TitleName, _Backbone$View);

    function TitleName() {
        _classCallCheck(this, TitleName);

        var _this = _possibleConstructorReturn(this, (TitleName.__proto__ || Object.getPrototypeOf(TitleName)).apply(this, arguments));

        _this.template = _TitleName2['default'];
        _this.render();
        return _this;
    }

    _createClass(TitleName, [{
        key: '_assembleLabel',
        value: function _assembleLabel() {
            var labelParts = [];

            labelParts.push(this.model.get('title'));

            if (!!this.model.get('firstCreatorName')) {
                labelParts.push(window.html('byLine', { creator: this.model.isMagazine ? this.model.get('publisher').name : this.model.get('firstCreatorName') }));
            }

            labelParts.push(this.model.availabilityText());

            labelParts.push(this.model.get('type').name);

            return labelParts.join(' ');
        }
    }, {
        key: 'render',
        value: function render() {
            var viewData = {
                titleId: this.model.id,
                href: this.model.titleDetailsUrl,
                ariaLabel: _.escape(this._assembleLabel()),
                title: _.escape(this.model.get('title'))
            };

            this.setElement($(this.template(viewData)));
        }
    }]);

    return TitleName;
}(Backbone.View);

exports['default'] = TitleName;

},{"../../templates/TitleName.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleName.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitlePreRelease.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitlePreRelease = require('../../templates/TitlePreRelease.html');

var _TitlePreRelease2 = _interopRequireDefault(_TitlePreRelease);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitlePreRelease = function (_Backbone$View) {
    _inherits(TitlePreRelease, _Backbone$View);

    function TitlePreRelease() {
        _classCallCheck(this, TitlePreRelease);

        var _this = _possibleConstructorReturn(this, (TitlePreRelease.__proto__ || Object.getPrototypeOf(TitlePreRelease)).apply(this, arguments));

        _this.template = _TitlePreRelease2['default'];


        if (!!_this.model.get('isPreReleaseTitle')) {
            _this.render();
        }
        return _this;
    }

    _createClass(TitlePreRelease, [{
        key: 'render',
        value: function render() {
            this.setElement($(this.template({ date: this.model.get('estimatedReleaseDate') })));
        }
    }]);

    return TitlePreRelease;
}(Backbone.View);

exports['default'] = TitlePreRelease;

},{"../../templates/TitlePreRelease.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitlePreRelease.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleSeries.js":[function(require,module,exports){
'use strict';

var Backbone = window.Backbone;
var url = window.url;
var routes = window.routes;
var windowText = window.text;
var featureManager = window.featureManager;

var TitleSeries = Backbone.View.extend({
    initialize: function initialize(_ref) {
        var hideSubtitle = _ref.hideSubtitle;

        this.useEnhancedSeries = featureManager.isEnabled('enhancedSeries') && typeof this.model.get('detailedSeries') !== 'undefined';
        this.hideSubtitle = hideSubtitle;

        this.listenTo(this.model, 'update', this.render);
        this.render();
    },
    render: function render() {
        var searchParams = this.useEnhancedSeries ? { type: 'seriesId', query: this.model.get('detailedSeries').seriesId, sortBy: 'readingOrder' } : { type: 'series', query: this.model.get('series'), sortBy: 'newlyadded' };

        var subtitleContainsSeries = this.model.get('subtitle') && this.model.get('subtitle').indexOf(this.model.get('series')) > -1;

        var seriesText = '';
        if (this.useEnhancedSeries) {
            var detailedSeries = this.model.get('detailedSeries');

            var formattedReadingOrder = detailedSeries.readingOrder % 1 === 0 ? detailedSeries.readingOrder.toFixed(0) : detailedSeries.readingOrder.toFixed(1);
            seriesText = window.text('enhancedSeriesLink', { seriesName: detailedSeries.seriesName, readingOrder: formattedReadingOrder });
        } else {
            seriesText = subtitleContainsSeries ? this.model.get('subtitle') : this.model.get('series') || '';
        }

        if (this.model.get('type').id === 'magazine') {
            searchParams.mediaType = 'magazine';
        }

        var viewModel = {
            id: this.model.get('id'),
            title: this.model.get('title'),
            series: seriesText,
            subtitle: this.model.get('subtitle') || '',
            searchUrl: url(routes.searchByType, searchParams),
            language: _.first(this.model.get('languages') || ['']),
            noCreators: _.isEmpty(this.model.get('creators'))
        };

        var $temp = $(document.createDocumentFragment());

        if (!this.hideSubtitle && !subtitleContainsSeries && !_.isEmpty(viewModel.subtitle)) {
            var $subtitle = this._buildSubtitle(viewModel.subtitle, viewModel.language);
            $temp.append($subtitle);
        }

        if (!_.isEmpty(viewModel.series)) {
            var $series = this._buildSeriesLink(viewModel.searchUrl, viewModel.noCreators, viewModel.series);
            $temp.append($series);
        }

        this.$el.html($temp);
    },
    _buildSeriesLink: function _buildSeriesLink(searchUrl, noCreators, text) {

        var $elm = $('<p />', { 'class': 'series ' + (noCreators ? 'no-author' : '') });

        var $link = $('<a />', {
            'aria-label': windowText('cover.searchBySeries', { series: text }),
            'class': 'series-link secondary-hover-underline',
            'href': searchUrl,
            'title': text,
            text: text
        });

        $elm.append($link);

        return $elm;
    },
    _buildSubtitle: function _buildSubtitle(subtitle, language) {
        return $('<p />', {
            'class': 'subtitle',
            'text': subtitle,
            'lang': language
        });
    }
});

module.exports = TitleSeries;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\rtl_preview\\RtlPreviewCollection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rtl_preview = require('./models/rtl_preview');

var _rtl_preview2 = _interopRequireDefault(_rtl_preview);

var _TitleCard = require('../media/TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleCollection = require('../media/models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

var _TitleCollectionView = require('../media/TitleCollectionView');

var _TitleCollectionView2 = _interopRequireDefault(_TitleCollectionView);

var _facets_controller = require('../../pages/facets/facets_controller');

var _facets_controller2 = _interopRequireDefault(_facets_controller);

var _PatronTitleStatus = require('../../models/PatronTitleStatus');

var _PatronTitleStatus2 = _interopRequireDefault(_PatronTitleStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RtlPreviewCollection = function (_Backbone$View) {
    _inherits(RtlPreviewCollection, _Backbone$View);

    // patronMediaItemsModel
    function RtlPreviewCollection(_ref) {
        var bus = _ref.bus,
            el = _ref.el,
            featureManager = _ref.featureManager;

        _classCallCheck(this, RtlPreviewCollection);

        var _this = _possibleConstructorReturn(this, (RtlPreviewCollection.__proto__ || Object.getPrototypeOf(RtlPreviewCollection)).call(this));

        _this.className = 'RTLRecommendations';
        _this.loaderTemplate = _.template('\n        <div class="loader">\n            <%= html(\'loading\') %>...\n        </div>');
        _this.template = _.template('\n        <div class="u-hr"></div>\n\n        <a href="javascript:void(0)" data-facet="recommend-to-library" class="seeAllButton u-pullRight u-allCaps">\n            <%= html(\'seeAll\') %>\n        </a>\n\n        <h2 tabindex="-1" class="title"><%= html(\'rtlRecommendations.didntFind\') %></h2>\n        <p class="subTitle">\n            <%= html(\'rtlRecommendations.weCanAddTitle\') %>\n        </p>\n\n        <ul class="titleContainer" style="margin: 0px;"></ul>');


        _this.bus = bus;
        _this.model = new _rtl_preview2['default']();
        _this.collection = new _TitleCollection2['default']();
        _this.facetsController = new _facets_controller2['default']();

        _this.setElement(el);
        _this.$el.empty().html(_this.loaderTemplate());

        if (featureManager.isEnabled('rtl-preview') && featureManager.isEnabled('recommend-to-library')) {
            _this.bus.on('search:render', function () {
                var waypoint = new window.Waypoint.Inview({
                    element: _this.$el,
                    enter: function enter() {
                        waypoint.destroy();
                        _this._update();
                    }
                });
            });
        } else {
            _this.$el.empty();
        }
        return _this;
    }

    _createClass(RtlPreviewCollection, [{
        key: '_update',
        value: function _update() {
            var _this2 = this;

            this.model.fetch().then(function (titles) {
                // Remove the control completely if there were no results returned
                if (_(titles).isEmpty()) {
                    _this2.$el.empty();
                    return;
                }

                var patronTitleStatus = new _PatronTitleStatus2['default']();
                patronTitleStatus.fetchTitleStatus(titles).then(function () {
                    patronTitleStatus.updateTitleCollectionState(_this2.collection);
                });

                _this2.collection.reset(titles);
                _this2.render();
            }).fail(function () {
                _this2.$el.empty();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            this.$el.empty().html(this.template());

            var facetsController = this.facetsController;

            this.$('.seeAllButton').on('click', function () {
                facetsController.select(this); // eslint-disable-line no-invalid-this
            });

            this.titleCollectionView = new _TitleCollectionView2['default']({
                el: this.$('.titleContainer'),
                bus: this.bus,
                View: _TitleCard2['default'],
                attributes: { 'class': 'titleContainer small-block-grid-2 medium-block-grid-4 large-block-grid-4' },
                collection: this.collection,
                coverWidths: { mobile: 215, tablet: 220, desktop: 220 }
            });
        }
    }]);

    return RtlPreviewCollection;
}(Backbone.View);

exports['default'] = RtlPreviewCollection;

},{"../../models/PatronTitleStatus":"C:\\projects\\lightning\\public\\ecmascript\\models\\PatronTitleStatus.js","../../pages/facets/facets_controller":"C:\\projects\\lightning\\public\\ecmascript\\pages\\facets\\facets_controller.js","../media/TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","../media/TitleCollectionView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js","../media/models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js","./models/rtl_preview":"C:\\projects\\lightning\\public\\ecmascript\\components\\rtl_preview\\models\\rtl_preview.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\rtl_preview\\models\\rtl_preview.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../models/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var queryPrefix = '?searchPath=';
if (window.location.search && window.location.search.indexOf('?') !== -1) {
    queryPrefix = window.location.search + '&searchPath=';
}

var query = queryPrefix + encodeURIComponent(window.location.pathname);

var RTLPreviewModel = _base2['default'].extend({
    urlRoot: function urlRoot() {
        var baseUrl = window.url(window.routes.rest.search.rtlPreview);

        return baseUrl + query;
    }
});

exports['default'] = RTLPreviewModel;

},{"../../../models/base":"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\models\\PatronTitleStatus.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Title = require('../components/media/models/Title');

var _Title2 = _interopRequireDefault(_Title);

var _TitleCollection = require('../components/media/models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is a replacement for PatronMediaItemsModel (ecmascript\models\patron_media_items.js)
// We should gradually transition to using this as time permits and we can take the time to validate funtionality
var PatronTitleStatus = function (_Backbone$Model) {
    _inherits(PatronTitleStatus, _Backbone$Model);

    function PatronTitleStatus() {
        _classCallCheck(this, PatronTitleStatus);

        return _possibleConstructorReturn(this, (PatronTitleStatus.__proto__ || Object.getPrototypeOf(PatronTitleStatus)).apply(this, arguments));
    }

    _createClass(PatronTitleStatus, [{
        key: 'fetchTitleStatus',
        value: function fetchTitleStatus(titleCollection) {
            var statusTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var titleArray = titleCollection.models || titleCollection || [];

            if (titleArray.length === 0) {
                return Promise.resolve();
            }

            var titleIds = _.map(_(titleArray).pluck('id'), Number);

            this.request = this.fetch({ data: JSON.stringify({ titleIds: titleIds, statusTypes: statusTypes }), type: 'POST', contentType: 'application/json' });

            return this.request;
        }

        /** @param {Title} title */

    }, {
        key: 'updateTitleState',
        value: function updateTitleState(title) {
            title.updatePatronState(this.attributes);
        }
    }, {
        key: 'updateTitleCollectionState',


        /** @param {TitleCollection} titleCollection */
        value: function updateTitleCollectionState(titleCollection) {
            var _this2 = this;

            // we provide an empty array for any status attributes that were not fetched
            // in order to avoid breaking anything downstream
            this.stubAttributes();
            this.titleIds.forEach(function (titleId) {
                var model = titleCollection.findWhere({ id: titleId });

                if (model) {
                    _this2.updateTitleState(model);
                }
            });
        }
    }, {
        key: 'stubAttributes',
        value: function stubAttributes() {
            if (!this.get('onReadingHistory')) {
                this.set('onReadingHistory', []);
            }
            if (!this.get('starRatings')) {
                this.set('starRatings', []);
            }
            if (!this.get('onCheckouts')) {
                this.set('onCheckouts', []);
            }
            if (!this.get('onHolds')) {
                this.set('onHolds', []);
            }
            if (!this.get('onWishlist')) {
                this.set('onWishlist', []);
            }
            if (!this.get('recommendedToLibrary')) {
                this.set('recommendedToLibrary', []);
            }
        }
    }, {
        key: 'url',
        get: function get() {
            return window.url(window.routes.mediaInfo);
        }
    }, {
        key: 'titleIds',
        get: function get() {
            return _.union(this.get('onReadingHistory'), _.keys(this.get('starRatings')), this.get('onCheckouts'), this.get('onHolds'), this.get('onWishlist'), this.get('recommendedToLibrary'));
        }
    }]);

    return PatronTitleStatus;
}(Backbone.Model);

exports['default'] = PatronTitleStatus;

},{"../components/media/models/Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","../components/media/models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js"}],"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import when we move more to modules
exports["default"] = window.Backbone.Model;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\models\\patron_media_items.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../models/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PatronMediaItemsModel = _base2['default'].extend({
    url: function url() {
        return window.url(window.routes.mediaInfo);
    },
    initialize: function initialize(_ref) {
        var titles = _ref.titles;

        this.mediaItems = titles || window.OverDrive.titleCollection || {};
        this.itemsOnPage = _.map(_.pluck(this.mediaItems, 'id'), Number);
    },
    initialFetch: function initialFetch() {
        return this.mediaItems.length ? this.fetch({
            data: JSON.stringify({ titleIds: this.itemsOnPage }),
            type: 'POST', contentType: 'application/json',
            headers: { 'csrf-token': $('#csrf').val() || OverDrive._csrf } }) : Promise.resolve({});
    }
});

exports['default'] = PatronMediaItemsModel;

},{"../models/base":"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\pages\\facets\\facets_controller.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rfc3986EncodeURIComponent = require('../../util/encoding/rfc3986EncodeURIComponent.js');

var _rfc3986EncodeURIComponent2 = _interopRequireDefault(_rfc3986EncodeURIComponent);

var _facets_model = require('./facets_model');

var _facets_model2 = _interopRequireDefault(_facets_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Controller logic for facets
 * @see js/public/faceted-media.js
 */

var FacetsController = function () {
    function FacetsController() {
        _classCallCheck(this, FacetsController);

        this.SHOW_ONLY_AVAILABLE = 'showOnlyAvailable';
        this.SHOW_ONLY_PRERELEASE = 'showOnlyPrerelease';
        this.SHOW_ALSO_RECOMMENDABLE = 'showAlsoRecommendable';
        this.ADDED_DATE = 'addedDate';
        this.REMOVE_FILTER = 'removeFilter';
        this.HAS_AUDIO_SYNCHRONIZED_TEXT = 'hasAudioSynchronizedText';
        this.SUBJECT = 'subject';
        this.FORMAT = 'format';
        this.MATURITY_LEVEL = 'maturityLevel';
        this.LANGUAGE = 'language';
        this.PAGE = 'page';
        this.SORT_BY = 'sortBy';
        this.EBOOK_OVERDRIVE_READALONG = 'ebook-overdrive-readalong';
        this.TRUE = 'true';
        this.INTEREST_LEVELS = 'interestLevels';
        this.GRADE_LEVELS = 'gradeLevels';
        this.ATOS_LEVELS = 'atosLevels';
        this.LEXILE_SCORES = 'lexileScores';
        var SINGLE_FACETS = [// single key-value pair facets
        this.SHOW_ONLY_AVAILABLE, this.SHOW_ONLY_PRERELEASE, this.SHOW_ALSO_RECOMMENDABLE, this.ADDED_DATE, this.REMOVE_FILTER, this.HAS_AUDIO_SYNCHRONIZED_TEXT];
        var MULTI_FACETS = [// multiple values for each name facets
        this.SUBJECT, this.FORMAT, this.MATURITY_LEVEL, this.LANGUAGE];
        var RANGE_FACETS = [this.INTEREST_LEVELS, this.GRADE_LEVELS, this.ATOS_LEVELS, this.LEXILE_SCORES];
        this._facetsModel = new _facets_model2['default'](SINGLE_FACETS, MULTI_FACETS, RANGE_FACETS);
    }

    /**
     * Returns a count of the facets from the model
     * @returns {*}
     */


    _createClass(FacetsController, [{
        key: 'countFacets',
        value: function countFacets() {
            return this._facetsModel.countFacets();
        }

        /**
         * Select a facet
         * @param {string} elem Selector string for facet element
         */

    }, {
        key: 'select',
        value: function select(elem) {
            // Prevent already active facets from being followed
            if (!$(elem).hasClass('js-active') && !$(elem).hasClass('js-disabled')) {
                this._facetsModel.beginTransaction();
                this._facetsModel.deleteOtherParam(this.PAGE);
                if ($(elem).data('facet') === 'narration') {
                    this._facetsModel.setFacet(this.HAS_AUDIO_SYNCHRONIZED_TEXT, this.TRUE);
                } else {
                    var facet = $(elem).attr('data-facet');
                    var id = $(elem).attr('data-id');
                    if (facet === 'available-now') {
                        this._facetsModel.setFacet(this.SHOW_ONLY_AVAILABLE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ONLY_PRERELEASE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ALSO_RECOMMENDABLE, this.TRUE);
                    } else if (facet === 'all-titles') {
                        this._facetsModel.unsetFacet(this.SHOW_ONLY_AVAILABLE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ONLY_PRERELEASE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ALSO_RECOMMENDABLE, this.TRUE);
                    } else if (facet === 'prerelease') {
                        this._facetsModel.setFacet(this.SHOW_ONLY_PRERELEASE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ONLY_AVAILABLE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ALSO_RECOMMENDABLE, this.TRUE);
                    } else if (facet === 'recommend-to-library') {
                        this._facetsModel.unsetFacet(this.SHOW_ONLY_AVAILABLE, this.TRUE);
                        this._facetsModel.unsetFacet(this.SHOW_ONLY_PRERELEASE, this.TRUE);
                        this._facetsModel.setFacet(this.SHOW_ALSO_RECOMMENDABLE, this.TRUE);
                        if ($('.js-searchSortByOptions').val() === 'newlyadded') {
                            this._facetsModel.setOtherParam(this.SORT_BY, 'releasedate');
                        } else if ($('.js-searchSortByOptions').val() === 'lowcirculating') {
                            this._facetsModel.setOtherParam(this.SORT_BY, 'mostpopular');
                        } else if ($('.js-searchSortByOptions').val() === 'mostpopular-site') {
                            this._facetsModel.setOtherParam(this.SORT_BY, 'mostpopular');
                        }
                    } else if (facet === this.SUBJECT) {
                        this._facetsModel.setFacet(this.SUBJECT, (0, _rfc3986EncodeURIComponent2['default'])(id));
                    } else if (facet === 'date') {
                        this._facetsModel.setFacet(this.ADDED_DATE, id);
                    } else if (facet === 'maturity') {
                        this._facetsModel.setFacet(this.MATURITY_LEVEL, id);
                    } else if ([this.FORMAT, this.LANGUAGE, this.INTEREST_LEVELS, this.GRADE_LEVELS, this.ATOS_LEVELS, this.LEXILE_SCORES].includes(facet)) {
                        this._facetsModel.setFacet(facet, id);
                    }
                }
                if (!this._facetsModel.hasOtherParam(this.SORT_BY)) {
                    this._facetsModel.setOtherParam(this.SORT_BY, $('.js-searchSortByOptions').val());
                }
                this._facetsModel.endTransaction();
            }
        }

        /**
         * Remove all active facets
         */

    }, {
        key: 'removeAll',
        value: function removeAll() {
            this._facetsModel.beginTransaction();
            this._facetsModel.deleteOtherParam(this.PAGE);
            this._facetsModel.unsetAllFacets();
            this._facetsModel.endTransaction();
        }

        /**
         * Removes `removeFilter` param for rooms
         */

    }, {
        key: 'restoreRoomFilter',
        value: function restoreRoomFilter(filter) {
            this._facetsModel.beginTransaction();
            this._facetsModel.unsetFacet(this.REMOVE_FILTER, filter);
            this._facetsModel.deleteOtherParam(this.PAGE);
            this._facetsModel.endTransaction();
        }

        /**
         * Remove an active facet
         * @param {string} elem Selector string for facet element
         */

    }, {
        key: 'remove',
        value: function remove(elem) {
            this._facetsModel.beginTransaction();
            var filterId = $(elem).attr('data-filter-id').split(',');
            var filterFacet = $(elem).attr('data-filter-facet');
            // Set page back to 1 when a facet is removed
            this._facetsModel.deleteOtherParam(this.PAGE);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = filterId[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var id = _step.value;

                    this._facetsModel.unsetFacet(filterFacet, (0, _rfc3986EncodeURIComponent2['default'])(id));
                    if (filterFacet === this.HAS_AUDIO_SYNCHRONIZED_TEXT) {
                        this._facetsModel.unsetFacet(this.FORMAT, this.EBOOK_OVERDRIVE_READALONG);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this._facetsModel.endTransaction();
        }

        /**
         * Remove a room filter
         * Requires adding another query parameter to indicate which filter to ignore
         */

    }, {
        key: 'removeRoomFilter',
        value: function removeRoomFilter(elem) {
            this._facetsModel.beginTransaction();
            var filterFacet = elem.data('filter-facet');
            var filterId = elem.data('filter-id');
            this._facetsModel.deleteOtherParam(this.PAGE);
            this._facetsModel.unsetFacet(filterFacet, filterId);
            this._facetsModel.setFacet(this.REMOVE_FILTER, filterFacet + '-' + filterId);
            this._facetsModel.endTransaction();
        }
    }]);

    return FacetsController;
}();

exports['default'] = FacetsController;

},{"../../util/encoding/rfc3986EncodeURIComponent.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\encoding\\rfc3986EncodeURIComponent.js","./facets_model":"C:\\projects\\lightning\\public\\ecmascript\\pages\\facets\\facets_model.js"}],"C:\\projects\\lightning\\public\\ecmascript\\pages\\facets\\facets_model.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _querystring = require('../../../../node_modules/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Model logic for facets
 * @see js/public/faceted-media.js
 */

var FacetsModel = function () {
    function FacetsModel(singleFacets, multiFacets, rangeFacets) {
        _classCallCheck(this, FacetsModel);

        this._params = _querystring2['default'].parse(window.location.search.substr(1)) || {};
        this._singleFacets = singleFacets; // single key-value pair facets
        this._multiFacets = multiFacets; // multiple values for each name facets
        this._rangeFacets = rangeFacets;
    }

    /**
     * Updates the stored parameters
     */


    _createClass(FacetsModel, [{
        key: 'beginTransaction',
        value: function beginTransaction() {
            this._params = _querystring2['default'].parse(window.location.search.substr(1)) || {};
        }

        /**
         * Reloads the page with the new query string
         */

    }, {
        key: 'endTransaction',
        value: function endTransaction() {
            if (!!window.OverDrive.titleCollection && !!window.OverDrive.titleCollection.maxItems && window.OverDrive.titleCollection.maxItems < 2147483647 && !!window.OverDrive.titleCollection.breakpoint) {
                this._params.breakpoint = window.OverDrive.titleCollection.breakpoint;
            }
            var qs = _querystring2['default'].stringify(this._params);

            qs = qs.length > 0 ? '?' + qs : qs;

            window.location.search = qs;
        }

        /**
         * Sets a facet with a name/value pair
         * @param name {string}
         * @param value {string}
         */

    }, {
        key: 'setFacet',
        value: function setFacet(name, value) {
            if (this._multiFacets.includes(name)) {
                if (!this._params[name]) {
                    this._params[name] = [value];
                } else if (!Array.isArray(this._params[name])) {
                    // if it was there only once it is a string
                    this._params[name] = [this._params[name], value];
                } else {
                    this._params[name].push(value);
                }
            } else if (this._singleFacets.includes(name)) {
                this._params[name] = value;
            } else if (this._rangeFacets.includes(name)) {
                var min = name + 'Min';
                var max = name + 'Max';
                this._params[min] = value;
                this._params[max] = value;
            }
        }

        /**
         * Unsets a facet with a name/value pair
         * @param {string} name the name of the facet
         * @param {string} value (optional) if undefined all elements with the name will be deleted
         */

    }, {
        key: 'unsetFacet',
        value: function unsetFacet(name, value) {
            if (this._rangeFacets.includes(name)) {
                var min = name + 'Min';
                var max = name + 'Max';
                delete this._params[min];
                delete this._params[max];
            } else if (!value || this._singleFacets.includes(name)) {
                delete this._params[name];
            } else if (this._multiFacets.includes(name)) {
                if (this._params[name] && Array.isArray(this._params[name])) {
                    this._params[name].splice(this._params[name].indexOf(value));
                    if (this._params[name].length === 0) {
                        delete this._params[name];
                    }
                } else {
                    delete this._params[name];
                }
            }
        }

        /**
         * Deletes all facets
         */

    }, {
        key: 'unsetAllFacets',
        value: function unsetAllFacets() {
            var _this = this;

            _.each(this._singleFacets, function (facet) {
                var name = facet;
                _this.unsetFacet(name);
            });
            _.each(this._multiFacets, function (facet) {
                var name = facet;
                _this.unsetFacet(name);
            });
            _.each(this._rangeFacets, function (facet) {
                var name = facet;
                _this.unsetFacet(name);
            });
        }

        /**
         * Deletes a parameter that is not a facet
         * @param name {string}
         */

    }, {
        key: 'deleteOtherParam',
        value: function deleteOtherParam(name) {
            if (!this._singleFacets.includes(name) && !this._multiFacets.includes(name)) {
                delete this._params[name];
            }
        }

        /**
         * Sets a parameter that is not a facet
         * @param {string} name the name of the facet to set
         * @param {string} value the facet's value
         */

    }, {
        key: 'setOtherParam',
        value: function setOtherParam(name, value) {
            if (!this._singleFacets.includes(name) && !this._multiFacets.includes(name)) {
                this._params[name] = value;
            }
        }

        /**
         * Checks for a parameter that is not a facet
         * @param {string} name  the name of the parameter
         * @returns {boolean} true if the parameter exists and it is not a facet
         */

    }, {
        key: 'hasOtherParam',
        value: function hasOtherParam(name) {
            if (!this._singleFacets.includes(name) && !this._multiFacets.includes(name)) {
                return !!this._params[name];
            }
            return false;
        }

        /**
         * Counts the facets for use by the clear all button to know if there are lozenges
         * that are clearable
         * @returns {number} the number of facets
         */

    }, {
        key: 'countFacets',
        value: function countFacets() {
            var count = 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._singleFacets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var facet = _step.value;

                    if (this._params[facet]) {
                        count++;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this._rangeFacets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _facet = _step2.value;

                    if (this._params[_facet + 'Min'] || this._params[_facet + 'Max']) {
                        count++;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                        _iterator2['return']();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this._multiFacets[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _facet2 = _step3.value;

                    if (this._params[_facet2]) {
                        if (Array.isArray(this._params[_facet2])) {
                            count += this._params[_facet2].length;
                        } else {
                            count++;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                        _iterator3['return']();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return count;
        }
    }]);

    return FacetsModel;
}();

exports['default'] = FacetsModel;

},{"../../../../node_modules/querystring":"C:\\projects\\lightning\\node_modules\\querystring\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\pages\\search.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _processForwardedAction = require('../util/title-actions/processForwardedAction');

var _processForwardedAction2 = _interopRequireDefault(_processForwardedAction);

var _patron_media_items = require('../models/patron_media_items');

var _patron_media_items2 = _interopRequireDefault(_patron_media_items);

var _HashManager = require('../components/common/HashManager');

var _HashManager2 = _interopRequireDefault(_HashManager);

var _TitleCollection = require('../components/media/models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

var _TitleCollectionView = require('../components/media/TitleCollectionView');

var _TitleCollectionView2 = _interopRequireDefault(_TitleCollectionView);

var _TitleCard = require('../components/media/TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleCardListView = require('../components/media/TitleCardListView');

var _TitleCardListView2 = _interopRequireDefault(_TitleCardListView);

var _TitleCollectionViewSelector = require('../components/media/views/TitleCollectionViewSelector');

var _TitleCollectionViewSelector2 = _interopRequireDefault(_TitleCollectionViewSelector);

var _PageManager = require('../components/collection_campaign_page/PageManager');

var _PageManager2 = _interopRequireDefault(_PageManager);

var _RtlPreviewCollection = require('../components/rtl_preview/RtlPreviewCollection');

var _RtlPreviewCollection2 = _interopRequireDefault(_RtlPreviewCollection);

var _facets_controller = require('./facets/facets_controller.js');

var _facets_controller2 = _interopRequireDefault(_facets_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _window = window,
    Logger = _window.Logger,
    featureManager = _window.featureManager;
var currentRoom = window.OverDrive.currentRoom;

var Search = function () {
    function Search(_ref) {
        var _this = this;

        var bus = _ref.bus,
            room = _ref.room,
            collectionDefinition = _ref.collectionDefinition;

        _classCallCheck(this, Search);

        this.bus = bus;
        this.room = room;
        this.collectionDefinition = collectionDefinition;

        this.$resultsContainer = $('.js-media-results');

        this.viewState = new _TitleCollectionViewSelector2['default']({ el: '.SearchViewOptions', bus: this.bus }).model;
        this.titleCollection = new _TitleCollection2['default'](this.titles);

        this.titleCollectionView = new _TitleCollectionView2['default']({
            collection: this.titleCollection,
            bus: this.bus,
            patronMediaItemsModel: new _patron_media_items2['default']({ titles: this.titles }),
            attributes: this.attributes,
            View: this.collectionView,
            coverWidths: this.coverWidths,
            context: {
                room: this.room,
                collectionDefinition: this.collectionDefinition
            }
        });

        this.viewState.on('change', function () {
            _this.titleCollectionView.View = _this.collectionView;
            _this.titleCollectionView.attributes = _this.attributes;
            _this.titleCollectionView.coverSizes = _this.coverWidths;
            _this.titleCollectionView.render();
        });

        this.handledForwardedAction = false;

        this.render();
    }

    _createClass(Search, [{
        key: 'render',
        value: function render() {
            $('.js-media-results').prepend(this.titleCollectionView.$el);

            /// $(document).foundation();

            // This event should happen after the search page is fully done rendering.
            // TODO: revisit this strategy when search page is fully componentized.
            // Slack reference: https://overdrive.slack.com/archives/lightning-dev/p1488381226000227
            window.globalEvents.trigger('search:render');

            // It's possible for render() to be called multiple times in some situations.  We don't want to trigger the action twice.
            if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards && _HashManager2['default'].get('action') && this.handledForwardedAction) {
                this.handledForwardedAction = true;
                var forwardedAction = new _processForwardedAction2['default'](this.titleCollection, this.bus);
                forwardedAction.executeAction();
                window.forwardAction = forwardedAction;
            }

            // Show pagination TODO: Refactor pagination into component to be appended to page here
            $('.Pagination.is-results').show();
        }
    }, {
        key: 'attributes',
        get: function get() {
            var attributes = {
                'class': 'js-title-collection-view large-block-grid-4 medium-block-grid-4 small-block-grid-2'
            };

            if (this.viewState.get('view') === 'list') {
                attributes['class'] = 'js-title-collection-view list-view-ul';
            }

            return attributes;
        }
    }, {
        key: 'coverWidths',
        get: function get() {
            if (this.viewState.get('view') === 'list') {
                return { mobile: 120, tablet: 160, desktop: 160 };
            }
            return { mobile: 220, tablet: 220, desktop: 220 };
        }
    }, {
        key: 'collectionView',
        get: function get() {
            var View = void 0;

            if (this.viewState.get('view') === 'list') {
                View = _TitleCardListView2['default'];
                this.$resultsContainer.removeClass('grid-view').addClass('list-view');
            } else {
                View = _TitleCard2['default'];
                this.$resultsContainer.removeClass('list-view').addClass('grid-view');
            }

            return View;
        }
    }, {
        key: 'titles',
        get: function get() {
            return window.OverDrive.titleCollection; // The source of data here is subject to change
        }
    }]);

    return Search;
}();

$('.RTLRecommendations').each(function (i, el) {
    void new _RtlPreviewCollection2['default']({ bus: window.globalEvents, el: el, featureManager: featureManager });
});

window.facetsController = new _facets_controller2['default']();

if (!!window.collectionId) {
    var pageManager = new _PageManager2['default']();

    pageManager.fetchCollectionById(window.collectionId).then(function (collectionDefinition) {
        void new Search({ bus: window.globalEvents, room: currentRoom, collectionDefinition: collectionDefinition });
    }, function (jqHXR, textStatus, error) {
        Logger.log('error', 'Error fetching collection', { message: textStatus });
    });
} else {
    void new Search({ bus: window.globalEvents, room: currentRoom });
}

},{"../components/collection_campaign_page/PageManager":"C:\\projects\\lightning\\public\\ecmascript\\components\\collection_campaign_page\\PageManager.js","../components/common/HashManager":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js","../components/media/TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","../components/media/TitleCardListView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCardListView.js","../components/media/TitleCollectionView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js","../components/media/models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js","../components/media/views/TitleCollectionViewSelector":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleCollectionViewSelector.js","../components/rtl_preview/RtlPreviewCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\rtl_preview\\RtlPreviewCollection.js","../models/patron_media_items":"C:\\projects\\lightning\\public\\ecmascript\\models\\patron_media_items.js","../util/title-actions/processForwardedAction":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processForwardedAction.js","./facets/facets_controller.js":"C:\\projects\\lightning\\public\\ecmascript\\pages\\facets\\facets_controller.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TitleActions = function () {
    function TitleActions(_ref) {
        var bus = _ref.bus,
            context = _ref.context;

        _classCallCheck(this, TitleActions);

        this.bus = bus;

        this.context = {
            room: undefined,
            collectionDefinition: undefined
        };

        _.extend(this.context, context);
    }

    _createClass(TitleActions, [{
        key: 'perform',
        value: function perform(action, titleModel) {
            if (typeof this['_' + action] === 'function') {
                this['_' + action](titleModel);
            }
        }
    }, {
        key: '_borrow',
        value: function _borrow(titleModel) {
            this.bus.trigger('title:borrow', titleModel, this.context);
        }
    }, {
        key: '_hold',
        value: function _hold(titleModel) {
            this.bus.trigger('title:hold', titleModel, this.context);
        }
    }, {
        key: '_wish',
        value: function _wish(titleModel) {
            this.bus.trigger('title:wishlist', titleModel, this.context);
        }
    }, {
        key: '_recommend',
        value: function _recommend(titleModel) {
            this.bus.trigger('title:recommend', titleModel, this.context);
        }
    }, {
        key: '_nook',
        value: function _nook(titleModel) {
            this.bus.trigger('title:nook', titleModel, this.context);
        }
    }, {
        key: '_rating',
        value: function _rating(titleModel) {
            this.bus.trigger('title:rating', titleModel, this.context);
        }
    }, {
        key: '_history',
        value: function _history(titleModel) {
            this.bus.trigger('title:history', titleModel, this.context);
        }
    }, {
        key: '_download',
        value: function _download(titleModel) {
            this.bus.trigger('title:download', titleModel, this.context);
        }
    }, {
        key: '_preview',
        value: function _preview(titleModel) {
            this.bus.trigger('title:preview', titleModel, this.context);
        }
    }, {
        key: '_renew',
        value: function _renew(titleModel) {
            this.bus.trigger('title:renew', titleModel, this.context);
        }
    }, {
        key: '_requestAgain',
        value: function _requestAgain(titleModel) {
            this.bus.trigger('title:requestAgain', titleModel, this.context);
        }
    }, {
        key: 'setContextRoom',
        value: function setContextRoom(room) {
            if (_(room).isEmpty()) {
                delete this.context.room;
            } else {
                this.context.room = room;
            }

            return this;
        }
    }, {
        key: 'setContextCollection',
        value: function setContextCollection(titleCollection) {
            if (_(titleCollection).isEmpty()) {
                delete this.context.titleCollection;
            } else {
                this.context.titleCollection = titleCollection;
            }

            return this;
        }
    }]);

    return TitleActions;
}();

exports['default'] = TitleActions;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleState.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TitleState = function () {
    function TitleState() {
        _classCallCheck(this, TitleState);
    }

    _createClass(TitleState, null, [{
        key: 'getState',
        value: function getState(media, patronItems) {
            var featureManager = window.featureManager;

            if (featureManager.isEnabled('internationalDemoMode')) {
                return 'preview';
            }

            var mediaId = media.id;

            var isOnHold = patronItems && patronItems.onHolds.indexOf(mediaId) > -1;
            var isOnCheckouts = patronItems && patronItems.onCheckouts.indexOf(mediaId) > -1;
            var isOnRecommendations = patronItems && patronItems.recommendedToLibrary.indexOf(mediaId) > -1 || media.isRecommended;
            var isAvailable = media.isAvailable || featureManager.isEnabled('LuckyDay') && media.luckyDayAvailableCopies > 0;

            if (/account\/loans/.test(window.location.href) && media.isRenewable && featureManager.isEnabled('content-holds')) {
                if (isOnHold) {
                    return 'requested';
                } else if (media.holdsCount <= 0 && media.ownedCopies >= 0 && !(featureManager.isEnabled('LuckyDay') && media.isLuckyDayCheckout) && featureManager.isEnabled('renewTitles')) {
                    return 'renew';
                }
                return 'requestAgain';
            }

            if (isOnCheckouts) {
                return 'borrowed';
            }

            if (isOnHold && !isAvailable) {
                return 'onHold';
            }

            if (isOnRecommendations && !isAvailable && !media.isHoldable) {
                return 'recommended';
            }

            if (isAvailable) {
                if (media.type.id === 'periodicals') {
                    return 'nook';
                }

                return 'borrow';
            }

            if (!media.isOwned && media.isRecommendableToLibrary && featureManager.isEnabled('recommend-to-library')) {
                return 'recommend';
            }

            if (media.isHoldable && featureManager.isEnabled('content-holds')) {
                return 'hold';
            }

            return 'unavailable';
        }
    }, {
        key: 'isOnWishlist',
        value: function isOnWishlist(media, patronItems) {
            return patronItems && patronItems.onWishlist.indexOf(media.id) > -1;
        }
    }, {
        key: 'isOnReadingHistory',
        value: function isOnReadingHistory(media, patronItems) {
            return patronItems && patronItems.onReadingHistory.indexOf(media.id) > -1;
        }
    }, {
        key: 'starRating',
        value: function starRating(media, patronItems) {
            // Returns 0 if not rated
            return patronItems && patronItems.starRatings && patronItems.starRatings[media.id] || 0;
        }
    }]);

    return TitleState;
}();

exports['default'] = TitleState;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\encoding\\rfc3986EncodeURIComponent.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Encode a string
 * @param {string} str String to be encoded
 * @returns {string}
 */
var rfc3986EncodeURIComponent = function rfc3986EncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[&!'()*]/g, escape);
};

exports["default"] = rfc3986EncodeURIComponent;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\forwardedActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recommend = undefined;

var _Title = require('../components/media/models/Title');

var _Title2 = _interopRequireDefault(_Title);

var _TitleActions = require('../title-actions/TitleActions');

var _TitleActions2 = _interopRequireDefault(_TitleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// process instant forward actions (refactored)
var recommend = function recommend(qs, action, bus) {
    if (action) {
        var mediaId = action.split('~')[1];
        var $actionLink = $('.js-recommend[data-media-id="' + mediaId + '"]');
        if ($actionLink.length > 0) {
            // remove the fragment
            history.replaceState(null, null, window.location.pathname + qs);

            // have to do a js click instead of jQuery on <a href>?
            $actionLink[0].click();
        } else {
            // Remove action from url
            history.replaceState(null, null, window.location.pathname + qs);
            var title = new _Title2['default']();
            var promise = new Promise(function (resolve, reject) {
                title.getTitleAsync(mediaId, resolve, reject);
            });

            promise.then(function () {
                var titleAction = new _TitleActions2['default']({ bus: bus });
                titleAction.perform('recommend', title);
            });
        }
    }
};

exports.recommend = recommend;

},{"../components/media/models/Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","../title-actions/TitleActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var keys = Object.freeze({
    TAB: 9,
    ENTER: 13,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SPACE: 32
});
exports["default"] = keys;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processForwardedAction.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HashManager = require('../../components/common/HashManager');

var _HashManager2 = _interopRequireDefault(_HashManager);

var _Title = require('../../components/media/models/Title');

var _Title2 = _interopRequireDefault(_Title);

var _TitleActions = require('../../title-actions/TitleActions');

var _TitleActions2 = _interopRequireDefault(_TitleActions);

var _forwardedActions = require('../forwardedActions.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProcessForwardedAction = function () {
    function ProcessForwardedAction(collection, bus, model) {
        _classCallCheck(this, ProcessForwardedAction);

        var hash = _HashManager2['default'].get('action')[0];
        this.actionArr = hash ? hash.split('~') : [];
        this.action = this.actionArr[0] || null;
        this.mediaId = this.actionArr[1] || null;
        this.rating = this.actionArr[2] || 0;
        this.model = model || null;
        this.collection = collection.models;
        this.bus = bus;
    }

    // Execute user forwarded action


    _createClass(ProcessForwardedAction, [{
        key: 'executeAction',
        value: function executeAction() {
            var _this = this;

            if (!this.action || !this.mediaId) {
                return;
            }

            if (!this.model || this.model && this.model.get('id') !== this.mediaId) {
                this.model = _.find(this.collection, function (model) {
                    return model.id === _this.mediaId;
                });
            }

            var titleActions = new _TitleActions2['default']({ bus: this.bus });

            if (this.model) {
                // Title model is on page
                _HashManager2['default'].remove('action');

                // LHTNG-1685 - Throw conflict modal if title is isOwned on a 'recommend' forwarded action
                if (this.action === 'recommend' && this.model.get('isOwned')) {
                    if (this.model.get('titleState') === 'borrow') {
                        this.bus.trigger('title:hold:conflict', { titleModel: this.model });
                    } else {
                        this.bus.trigger('title:borrow:conflict', { titleModel: this.model });
                    }

                    return;
                }

                this.model.set('userStarRating', this.rating);
                titleActions.perform(this.action, this.model);
            } else if (this.action === 'recommend' && $('a.primary-action[data-media-id="' + this.mediaId + '"]').length > 0) {
                // Recommended from the preview row
                // Remove after RTL preview row is refactored
                (0, _forwardedActions.recommend)('', this.action, this.bus);
                _HashManager2['default'].remove('action');
            } else {
                // Title model is not on page, fetch async
                var title = new _Title2['default']();
                var promise = new Promise(function (resolve, reject) {
                    title.getTitleAsync(_this.mediaId, resolve, reject);
                });

                promise.then(function () {
                    _this.model && _this.model.set('userStarRating', _this.rating);
                    titleActions.perform(_this.action, title);
                    _HashManager2['default'].remove('action');
                });
            }
        }
    }]);

    return ProcessForwardedAction;
}();

exports['default'] = ProcessForwardedAction;

},{"../../components/common/HashManager":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js","../../components/media/models/Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","../../title-actions/TitleActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js","../forwardedActions.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\forwardedActions.js"}]},{},["C:\\projects\\lightning\\public\\ecmascript\\pages\\search.js"])

